import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, Input, Output, Optional, Inject, ViewChild, isDevMode, forwardRef, Pipe, TemplateRef, ContentChild, HostListener, Directive, HostBinding, NgModule } from '@angular/core';
import * as i1 from '@pershing/pershing-core';
import { CommonUtil, CoreConstants, PershingHttpUtil, PershingCoreModule } from '@pershing/pershing-core';
import { Subject, BehaviorSubject, fromEvent, interval } from 'rxjs';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/common';
import * as i4 from '@angular/material/legacy-button';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import * as i5 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from '@angular/material/legacy-menu';
import { MatLegacyMenu, MatLegacyMenuTrigger, MatLegacyMenuModule } from '@angular/material/legacy-menu';
import * as i8 from '@angular/material/legacy-tooltip';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import * as i9 from '@ngx-translate/core';
import * as i2$1 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import { throttleTime, debounceTime, takeUntil, startWith, map } from 'rxjs/operators';
import * as i4$1 from '@angular/material/legacy-progress-spinner';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import * as i2$2 from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import * as i1$1 from '@angular/platform-browser';
import * as i1$2 from '@pershing/ngx-responsive2';
import * as i4$2 from '@angular/material/legacy-form-field';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import * as i5$1 from '@angular/material/legacy-input';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import * as i6$1 from '@angular/material/legacy-autocomplete';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import * as i7$1 from '@angular/material/legacy-core';
import { MatLegacyOptionModule } from '@angular/material/legacy-core';
import * as i2$3 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i2$4 from '@angular/router';

class ActionMenuLabels {
    static { this.HOLDINGS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.HOLDINGS'; }
    static { this.ACTIVITY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.ACTIVITY'; }
    static { this.BALANCES = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BALANCES'; }
    static { this.PROJ_CASH_FLOW = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.PROJ_CASH_FLOW'; }
    static { this.HOLDINGS_BY_SYMBOL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.HOLDINGS_BY_SYMBOL'; }
    static { this.ACCOUNT_ACTIVITY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.ACCOUNT_ACTIVITY'; }
    static { this.VIEW_ACCOUNTS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.VIEW_ACCOUNTS'; }
    static { this.VIEW_IP_TOTALS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.VIEW_IP_TOTALS'; }
    static { this.QUOTES = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.QUOTES'; }
    static { this.DIGEST = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.DIGEST'; }
    static { this.OPTION_QUOTE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.OPTION_QUOTE'; }
    static { this.NEWS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.NEWS'; }
    static { this.BUY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY'; }
    static { this.BUY_MORE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_MORE'; }
    static { this.SELL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL'; }
    static { this.SELL_FROM_POSITIONS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_FROM_POSITIONS'; }
    static { this.SELL_COVERED_CALLS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_COVERED_CALLS'; }
    static { this.SELL_ALL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_ALL'; }
    static { this.SELL_SHORT = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_SHORT'; }
    static { this.BUY_TO_COVER = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_TO_COVER'; }
    static { this.REDEEM = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.REDEEM'; }
    static { this.REDEEM_ALL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.REDEEM_ALL'; }
    static { this.EXCHANGE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.EXCHANGE'; }
    static { this.EXCHANGE_ALL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.EXCHANGE_ALL'; }
    static { this.BUY_CALLS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_CALLS_TO_OPEN'; }
    static { this.SELL_CALLS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_CALLS_TO_OPEN'; }
    static { this.BUY_PUTS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.BUY_PUTS_TO_OPEN'; }
    static { this.SELL_PUTS_TO_OPEN = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_PUTS_TO_OPEN'; }
    static { this.CLOSE_CALLS_PUTS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CLOSE_CALLS_PUTS'; }
    static { this.ROLL = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.ROLL'; }
    static { this.TRADE_AWAY = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.TRADE_AWAY'; }
    static { this.CFRA_QUICK_VIEW = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CFRA_QUICK_VIEW'; }
    static { this.ADD_NOTE = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.ADD_NOTE'; }
    static { this.CALCULATE_LOI_ROA = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CALCULATE_LOI_ROA'; }
    static { this.SELL_POSITIONS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_POSITIONS'; }
    static { this.PERIODIC_INSTRUCTIONS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.PERIODIC_INSTRUCTIONS'; }
    static { this.DIVIDEND_REINVEST = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.DIVIDEND_REINVEST'; }
    static { this.DISPOSITION_METHOD = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.DISPOSITION_METHOD'; }
    static { this.CALCULATE_CDSC = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CALCULATE_CDSC'; }
    static { this.CHART = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.CHART'; }
    static { this.HISTORICAL_PRICES = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.HISTORICAL_PRICES'; }
    static { this.SELL_FROM_HOLDINGS = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.SELL_FROM_HOLDINGS'; }
    static { this.OPEN_IN_NEW_TAB = 'NXP-PERSHING-COMMON.NXP_ACTION_MENU.OPEN_IN_NEW_TAB'; }
}

class NxpActionMenuConfig {
    static { this.ID_DIVIDER = 'divider'; }
    static { this.ID_HOLDINGS = 'holdings'; }
    static { this.ID_ACTIVITY = 'activity'; }
    static { this.ID_BALANCES = 'balances'; }
    static { this.ID_PCF = 'pcf'; }
    static { this.ID_HOLDINGS_BY_SYMBOL = 'holdings-by-symbol'; }
    static { this.ID_ACCOUNT_ACTIVITY = 'account-activity'; }
    static { this.ID_VIEW_ACCOUNTS = 'view-accounts'; }
    static { this.ID_VIEW_IP_TOTALS = 'view-iptotals'; }
    static { this.ID_QUOTES = 'quotes'; }
    static { this.ID_QUOTES_MF = 'investment-center'; }
    static { this.ID_DIGEST = 'digest'; }
    static { this.ID_SECURITY_NEWS = 'security-news'; }
    static { this.ID_TRADE_BUY_MORE_EQUITY = 'trade-buy-more-equity'; }
    static { this.ID_HOLDINGS_BUY_MORE_EQUITY = 'holdings-buy-more-equity'; }
    static { this.ID_TRADE_SELL_EQUITY = 'trade-sell-equity'; }
    static { this.ID_TRADE_SELL_POSITIONS = 'trade-sell-positions'; }
    static { this.ID_TRADE_SELL_COVERED = 'trade-sell-covered'; }
    static { this.ID_TRADE_SELL_ALL_EQUITY = 'trade-sell-all-equity'; }
    static { this.ID_TRADE_SELL_SHORT = 'trade-sell-short'; }
    static { this.ID_TRADE_BUY_TO_COVER = 'trade-buy-to-cover'; }
    static { this.ID_TRADE_BUY_MF = 'trade-buy-mf'; }
    static { this.ID_TRADE_BUY_529 = 'trade-buy-mf-529plan'; }
    static { this.ID_TRADE_REDEEM = 'trade-redeem'; }
    static { this.ID_TRADE_REDEEM_529 = 'trade-redeem-mf-529plan'; }
    static { this.ID_TRADE_EXCHANGE = 'trade-exchange'; }
    static { this.ID_TRADE_EXCHANGE_529 = 'trade-exchange-mf-529plan'; }
    static { this.ID_TRADE_BUY_CALLS_TO_OPEN = 'trade-buy-calls-to-open'; }
    static { this.ID_TRADE_SELL_CALLS_TO_OPEN = 'trade-sell-calls-to-open'; }
    static { this.ID_TRADE_BUY_PUTS_TO_OPEN = 'trade-buy-puts-to-open'; }
    static { this.ID_TRADE_SELL_PUTS_TO_OPEN = 'trade-sell-puts-to-open'; }
    static { this.ID_TRADE_CLOSE_CALLS_PUTS = 'trade-close-calls-puts'; }
    static { this.ID_TRADE_ROLL = 'trade-roll'; }
    static { this.ID_TRADE_AWAY_FI = 'trade-away-fi'; }
    static { this.ID_TRADE_SELL_FI = 'trade-sell-fi'; }
    static { this.ID_CFRA_QUICKVIEW = 'cfra-quickview'; }
    static { this.ID_ACCOUNT_NOTE = 'account-note'; }
    static { this.ID_CALCULATE_LOI_ROA = 'calculate-loiroa'; }
    static { this.ID_SELL_POSITIONS = 'sell-positions'; }
    static { this.ID_PERIODIC_INSTRUCTIONS = 'periodic-instructions'; }
    static { this.ID_DIVIDEND_REINVEST = 'dividend-reinvestment'; }
    static { this.ID_DISPOSITION_METHOD = 'disposition-method'; }
    static { this.ID_CALCULATE_CDSC = 'calculate-cdsc'; }
    static { this.ID_TRADE_SELL_COVERED_OPTIONS = 'trade-sell-covered-options'; }
    static { this.ID_CHART = 'chart'; }
    static { this.ID_HISTORICAL_PRICE = 'historical-price'; }
    static { this.ID_OTS_ROLLOVER_ACTIVITY = 'ots-rollover-activity'; }
    static { this.ID_SELL_FROM_HOLDINGS = 'sell-from-holdings'; }
    static { this.ID_TRADE_REDEEM_ALL = 'trade-redeem-all'; }
    static { this.ID_TRADE_EXCHANGE_ALL = 'trade-exchange-all'; }
    static { this.ID_TRADE_REDEEM_ALL_529 = 'trade-redeem-all-mf-529plan'; }
    static { this.ID_TRADE_EXCHANGE_ALL_529 = 'trade-exchange-all-mf-529plan'; }
    /* Default navigation target for the context types */
    static { this.DEFAULT_NAVTARGET_CONTEXT = {
        account: 'holdings/positions',
        household: 'holdings/positions',
        group: 'holdings/positions',
        client: 'holdings/positions',
        clntaccnt_search: 'holdings/positions',
    }; }
    /* Below is to handle the domain value sent in the search response until we standardize the contexts */
    static { this.DEFAULT_NAVTARGET_ACTIONS = {
        balances: 'balances/balance-summary',
        holdings: 'holdings/positions',
        activity: 'activity',
        pcf: 'pcf/incoming-cash',
    }; }
    static { this.NXP_ACTION_MENU_DUPLICATE_MAPPING = new Map([
        ['account-OPEN', 'account'],
        ['security-commonstocks', 'security-equity'],
        ['security-moneymkt', 'security-mutfund'],
        ['security-municipalbonds', 'security-fixedincome'],
        ['security-munidebt', 'security-fixedincome'],
        ['security-uit', 'security-fixedincome'],
        ['security-govtsec', 'security-fixedincome'],
    ]); }
    /*
      NXP_ACTION_MENU_MASTER object defines the menu items for the context menu.
  
      Structure is as follows.
  
          <menuobject_name>: {
              menuId: 'xyx', // Used internally
              menuLabel: 'xyz', // Displayed to the user
              gotoPage: 'nav_target', // Default navigation target
              callbackEvent: 'eventName', // Name of the event to be used to communicate back to the component
              role: 'entitlements', // Requied entitlements. Need to be configured in portal services.
              payloadMetadata: {}, // An object that provides the list of parameters that need to be passed to target
              disabled: true/false, // True if the menu should not be displayed. By default, false.
              icon: 'icon_class' // Add an icon name if needed. For future use.
          }
  
          payloadMetadata has a member named params which supplies the list of parameters to pass to target application.
  
          Sample:
          payloadMetadata: {
              params: 'symId,acctType,transactionType=BUY,PrepopTrdtype=Buy,qty={quantity}'
          }
  
          Each attribute in the params list will be used to get the value from the payload.params object passed by the component.
  
          For cases where the parameter name that needs to be passed to target application and the attribute coming from the component
          are different, we indicate the value with {}.
  
          Eg: qty={quantity} - qty is the parameter that target expects whereas the component model has it as quantity.
  
          For these cases, take the attribute name within the paranthesis and find and use the value for the attribute from incoming payload.
  
          An event with the value supplied in 'callbackEvent' will be triggered when the menu is clicked,
          if this attribute is passed by the component.
  
      */
    static { this.NXP_ACTION_MENU_MASTER = {
        divider: {
            menuId: 'divider',
            menuLabel: '',
            gotoPage: '',
            isDivider: true,
        },
        holdings: {
            menuId: 'holdings',
            menuLabel: ActionMenuLabels.HOLDINGS,
            gotoPage: 'holdings/positions',
        },
        activity: {
            menuId: 'activity',
            menuLabel: ActionMenuLabels.ACTIVITY,
            gotoPage: 'activity',
        },
        balances: {
            menuId: 'balances',
            menuLabel: ActionMenuLabels.BALANCES,
            gotoPage: 'balances/balance-summary',
        },
        pcf: {
            menuId: 'pcf',
            menuLabel: ActionMenuLabels.PROJ_CASH_FLOW,
            gotoPage: 'pcf/incoming-cash',
        },
        'holdings-by-symbol': {
            menuId: 'holdings-by-symbol',
            menuLabel: ActionMenuLabels.HOLDINGS_BY_SYMBOL,
            gotoPage: 'holdings-bysymbol-ibdoffip',
            payloadMetadata: {
                params: 'securityType, securityValue, domaintype=ibdoffip, publisherId=main-menu, assetType',
            },
            domain: 'ibdoffip',
        },
        'account-activity': {
            menuId: 'account-activity',
            menuLabel: ActionMenuLabels.ACCOUNT_ACTIVITY,
            gotoPage: 'activity',
            payloadMetadata: {
                params: 'securityType, securityValue',
            },
            domain: 'account',
            disabled: true,
        },
        'view-accounts': {
            menuId: 'view-accounts',
            menuLabel: ActionMenuLabels.VIEW_ACCOUNTS,
            gotoPage: 'holdings-bysymbol-ibdoffip',
            payloadMetadata: {
                params: 'securityType, securityValue, domaintype=ibdoffip, publisherId=main-menu',
            },
            domain: 'ibdoffip',
            enableMultitabPopout: true,
        },
        'view-iptotals': {
            menuId: 'view-iptotals',
            menuLabel: ActionMenuLabels.VIEW_IP_TOTALS,
            gotoPage: 'holdings-iptotals-ibdoffip',
            payloadMetadata: {
                params: 'securityType, securityValue, domaintype=ibdoffip, publisherId=main-menu',
            },
            domain: 'ibdoffip',
            enableMultitabPopout: true,
        },
        quotes: {
            menuId: 'quotes',
            menuLabel: ActionMenuLabels.QUOTES,
            gotoPage: 'security-digest',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip',
            },
            domain: 'security',
        },
        'investment-center': {
            menuId: 'investment-center',
            menuLabel: ActionMenuLabels.QUOTES,
            gotoPage: 'investment-center',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip, parentId=investment-center, childId=funds, gotoPage=funds, activeTabKey=profile',
            },
            domain: 'security',
        },
        digest: {
            menuId: 'digest',
            menuLabel: ActionMenuLabels.DIGEST,
            gotoPage: 'security-digest',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip',
            },
            domain: 'security',
        },
        'security-news': {
            menuId: 'security-news',
            menuLabel: ActionMenuLabels.NEWS,
            gotoPage: 'security-digest',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip',
            },
            domain: 'security',
        },
        /* 'trade-buy-equity' : {
                menuId: 'trade-buy',
                menuLabel: ActionMenuLabels.BUY,
                disabled: false,
                icon: 'fa-money',
                gotoPage: 'trading/new-order-entry/equity-order',
                payloadMetadata: {
                    params: 'symId, , symbolRollOver={symId}, acctType, transactionType=BUY, PrepopTrdtype=Buy, rollOverIndicator=1'
                }
            },*/
        'trade-buy-more-equity': {
            menuId: 'trade-buy-more-equity',
            menuLabel: ActionMenuLabels.BUY,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType,transactionType=BUY, PrepopTrdtype=Buy, rollOverIndicator=1',
            },
            domain: 'account',
        },
        'holdings-buy-more-equity': {
            menuId: 'holdings-buy-more-equity',
            menuLabel: ActionMenuLabels.BUY_MORE,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, acctType,transactionType=BUY, PrepopTrdtype=Buy, rollOverIndicator=1, balanceType',
            },
            domain: 'account',
            disabled: true,
        },
        /*
            'trade-sell-equity' : {
                menuId: 'trade-sell-equity',
                menuLabel: ActionMenuLabels.SELL,
                gotoPage: 'trading/new-order-entry/equity-order',
                role: 'EQT_ORD_ENTRY',
                payloadMetadata: {
                    params: 'symId, symbolRollOver={symId}, acctType, transactionType, PrepopTrdtype,qty'
                },
                domain: 'account'
            },
            */
        'trade-sell-positions': {
            menuId: 'trade-sell-positions',
            menuLabel: ActionMenuLabels.SELL,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=SELL_FROM_PORTFOLIO, PrepopTrdtype=Sell, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-sell-covered': {
            menuId: 'trade-sell-covered',
            menuLabel: ActionMenuLabels.SELL_COVERED_CALLS,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, neSymbol={symId}, acctType, accountType={acctType}, transactionType=WRITE_A_COVERED_CALL, transtype=WRITE COVERED CALLS, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-sell-all-equity': {
            menuId: 'trade-sell-all-equity',
            menuLabel: ActionMenuLabels.SELL_ALL,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY || ORDER_BLASTING',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=SELL_ALL, pcfnTransactionType=Sell, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-sell-short': {
            menuId: 'trade-sell-short',
            menuLabel: ActionMenuLabels.SELL_SHORT,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=SELL_SHORT, pcfnTransactionType=Sell Short, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-buy-to-cover': {
            menuId: 'trade-buy-to-cover',
            menuLabel: ActionMenuLabels.BUY_TO_COVER,
            gotoPage: 'trading/new-order-entry/equity-order',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType=BUY_TO_COVER, pcfnTransactionType=Buy to Cover, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-sell-covered-options': {
            menuId: 'trade-sell-covered-options',
            menuLabel: ActionMenuLabels.SELL_COVERED_CALLS,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver={symId}, neSymbol={symId}, acctType, accountType={acctType}, transactionType=WRITE_A_COVERED_CALL, transtype=WRITE COVERED CALLS, qty, balanceType',
            },
            domain: 'account',
            disabled: true,
        },
        'trade-buy-mf': {
            menuId: 'trade-buy-mf',
            menuLabel: ActionMenuLabels.BUY,
            gotoPage: 'trading/new-order-entry/mutual-fund-order',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbolRollOver={securityId}, transactionType=BUY, selection=mfbuy1.trl, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-buy-mf-529plan': {
            menuId: 'trade-buy-mf-529plan',
            menuLabel: ActionMenuLabels.BUY,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=BUY, transaction=Buy, qty, securityId, balanceType',
            },
            domain: 'account',
            disabled: true,
        },
        'trade-redeem': {
            menuId: 'trade-redeem',
            menuLabel: ActionMenuLabels.REDEEM,
            gotoPage: 'mutual-fund-redeem',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbolRollOver={securityId}, transactionType=REDEEM, selection=mfdeem1.trl, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-redeem-all': {
            menuId: 'trade-redeem-all',
            menuLabel: ActionMenuLabels.REDEEM_ALL,
            gotoPage: 'mutual-fund-redeem',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbolRollOver={securityId}, transactionType=REDEEM_ALL, selection=mfdeem1.trl, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-redeem-mf-529plan': {
            menuId: 'trade-redeem-mf-529plan',
            menuLabel: ActionMenuLabels.REDEEM,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=REDEEM, transaction=Redeem, qty, securityId, balanceType',
            },
            domain: 'account',
            disabled: true,
        },
        'trade-redeem-all-mf-529plan': {
            menuId: 'trade-redeem-all-mf-529plan',
            menuLabel: ActionMenuLabels.REDEEM_ALL,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=REDEEM_ALL, transaction=REDEEM_ALL, qty, securityId, balanceType'
            },
            domain: 'account',
            disabled: true
        },
        'trade-exchange': {
            menuId: 'trade-exchange',
            menuLabel: ActionMenuLabels.EXCHANGE,
            gotoPage: 'mutual-fund-exchange',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbolRollOver={securityId}, transactionType=EXCHANGE, selection=federatedxch1.trl, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-exchange-all': {
            menuId: 'trade-exchange-all',
            menuLabel: ActionMenuLabels.EXCHANGE_ALL,
            gotoPage: 'mutual-fund-exchange',
            role: 'MF_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbolRollOver={securityId}, transactionType=EXCHANGE_ALL, selection=federatedxch1.trl, qty, balanceType',
            },
            domain: 'account',
        },
        'trade-exchange-mf-529plan': {
            menuId: 'trade-exchange-mf-529plan',
            menuLabel: ActionMenuLabels.EXCHANGE,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=EXCHANGE, transaction=Exchange, qty, securityId, balanceType',
            },
            domain: 'account',
            disabled: true,
        },
        'trade-exchange-all-mf-529plan': {
            menuId: 'trade-exchange-all-mf-529plan',
            menuLabel: ActionMenuLabels.EXCHANGE_ALL,
            gotoPage: 'trading/new-order-entry/fund-529-order',
            role: 'PLAN_529_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId={securityId}, symbol={securityId}, symbolRollOver={symId}, transactionType=EXCHANGE_ALL, transaction=EXCHANGE_ALL, qty, securityId, balanceType'
            },
            domain: 'account',
            disabled: true
        },
        'trade-buy-calls-to-open': {
            menuId: 'trade-buy-calls-to-open',
            menuLabel: ActionMenuLabels.BUY_CALLS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symbolRollOver={rootId}, symId, neSymbol={symId}, acctType, accounttype={acctType}, transactionType=BUY_CALL_TO_OPEN, transtype=BUY CALLS TO OPEN',
            },
            domain: 'account',
        },
        'trade-sell-calls-to-open': {
            menuId: 'trade-sell-calls-to-open',
            menuLabel: ActionMenuLabels.SELL_CALLS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symbolRollOver={rootId}, symId, neSymbol={symId}, acctType, accounttype={acctType}, transactionType=SELL_CALL_TO_OPEN, transtype=SELL CALLS TO OPEN',
            },
            domain: 'account',
        },
        'trade-buy-puts-to-open': {
            menuId: 'trade-buy-puts-to-open',
            menuLabel: ActionMenuLabels.BUY_PUTS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symbolRollOver={rootId}, symId, neSymbol={symId}, acctType, accounttype={acctType}, transactionType=BUY_PUT_TO_OPEN, transtype=BUY PUTS TO OPEN',
            },
            domain: 'account',
        },
        'trade-sell-puts-to-open': {
            menuId: 'trade-sell-puts-to-open',
            menuLabel: ActionMenuLabels.SELL_PUTS_TO_OPEN,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symbolRollOver={rootId}, symId, neSymbol={symId}, acctType, accounttype={acctType}, transactionType=SELL_PUT_TO_OPEN, transtype=SELL PUTS TO OPEN',
            },
            domain: 'account',
        },
        'trade-close-calls-puts': {
            menuId: 'trade-close-calls-puts',
            menuLabel: ActionMenuLabels.CLOSE_CALLS_PUTS,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symbolRollOver={rootId}, symId, neSymbol={symId}, acctType, accounttype={acctType}, transactionType=CLOSE_CALL_PUTS, transtype=CLOSE CALLS AND PUTS',
            },
            domain: 'account',
        },
        'trade-roll': {
            menuId: 'trade-roll',
            menuLabel: ActionMenuLabels.ROLL,
            gotoPage: 'trading/new-order-entry/option-order',
            role: 'OPT_ORD_ENTRY_ROLL',
            payloadMetadata: {
                params: 'symId, neSymbol={symId}, acctType, transactionType, strategy=ROLL, isComplex=true, defaultToNewExpView=true',
            },
            domain: 'account',
            disabled: true,
        },
        'trade-away-fi': {
            menuId: 'trade-away-fi',
            menuLabel: ActionMenuLabels.TRADE_AWAY,
            gotoPage: 'trading.orderentry.ficenter',
            role: 'EQT_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, symbolRollOver, acctType, transactionType, pcfnTransactionType, qty',
            },
            domain: 'account',
        },
        'trade-sell-fi': {
            menuId: 'trade-sell-fi',
            menuLabel: ActionMenuLabels.SELL,
            gotoPage: 'trading.orderentry.ficenter',
            role: 'FI_ORD_ENTRY',
            payloadMetadata: {
                params: 'symId, acctType, transactionType, pcfnTransactionType, qty',
            },
            domain: 'account',
        },
        'cfra-quickview': {
            menuId: 'cfra-quickview',
            menuLabel: ActionMenuLabels.CFRA_QUICK_VIEW,
            gotoPage: 'cfra-quick-view',
            role: 'CFRA_STK_RPT',
            payloadMetadata: {
                params: 'symId, symbol, cusip',
            },
            domain: 'security',
        },
        'account-note': {
            menuId: 'account-note',
            menuLabel: ActionMenuLabels.ADD_NOTE,
            gotoPage: 'my-practice/details/notes',
            role: 'ADD_NOTES',
            payloadMetadata: {
                params: 'domaintype=account, addnote=true, notedesc, gridData',
            },
            domain: 'account',
            disabled: true,
        },
        'calculate-loiroa': {
            menuId: 'calculate-loiroa',
            menuLabel: ActionMenuLabels.CALCULATE_LOI_ROA,
            disabled: true,
        },
        'sell-positions': {
            menuId: 'sell-positions',
            menuLabel: ActionMenuLabels.SELL_POSITIONS,
            gotoPage: 'sell-positions',
            role: 'ORDER_BLASTING',
            payloadMetadata: {
                params: `strategy=buysell, assettype, transtype, symbol, cusip,` +
                    `groupsrccd, groupcreatorid, groupid, groupname, accounts`,
            },
            domain: 'group',
        },
        'periodic-instructions': {
            menuId: 'periodic-instructions',
            menuLabel: ActionMenuLabels.PERIODIC_INSTRUCTIONS,
            gotoPage: 'periodicinstructions-account',
            domain: 'account',
            disabled: true,
        },
        'dividend-reinvestment': {
            menuId: 'dividend-reinvestment',
            menuLabel: ActionMenuLabels.DIVIDEND_REINVEST,
            disabled: true,
        },
        'disposition-method': {
            menuId: 'disposition-method',
            menuLabel: ActionMenuLabels.DISPOSITION_METHOD,
            disabled: true,
        },
        'calculate-cdsc': {
            menuId: 'calculate-cdsc',
            menuLabel: ActionMenuLabels.CALCULATE_CDSC,
            disabled: true,
        },
        'ots-rollover-activity': {
            menuId: 'ots-rollover-activity',
            menuLabel: ActionMenuLabels.ACTIVITY,
            gotoPage: 'activity',
            payloadMetadata: {
                params: 'domaintype=account, brokerType',
            },
            domain: 'account',
            disabled: true,
        },
        chart: {
            menuId: 'chart',
            menuLabel: ActionMenuLabels.CHART,
            gotoPage: 'chart',
            role: 'SUMMARY',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip, screen=WWW_CHART',
            },
            domain: 'security',
            disabled: true,
        },
        'historical-price': {
            menuId: 'historical-price',
            menuLabel: ActionMenuLabels.HISTORICAL_PRICES,
            gotoPage: 'historical-price',
            role: 'SUMMARY',
            payloadMetadata: {
                params: 'securityType, securityValue, symbol, cusip, screen=WWW_HIST_QUOTE',
            },
            domain: 'security',
            disabled: true,
        },
        'sell-from-holdings': {
            menuId: 'sell-from-holdings',
            menuLabel: ActionMenuLabels.SELL_FROM_HOLDINGS,
            role: 'SELL_FIXED_INCOME',
            disabled: true,
        },
    }; }
    static { this.NXP_ACTION_MENU_CONFIG = {
        emptylist: [],
        divider: ['divider'],
        account: ['holdings', 'balances', 'activity', 'pcf'],
        'account-closed': ['holdings', 'balances', 'activity', 'pcf'],
        'account-pending': ['holdings', 'balances', 'activity', 'pcf'],
        'account-managed': ['holdings', 'balances', 'activity', 'pcf'],
        'account-awaycustoday': ['holdings', 'balances'],
        household: ['holdings', 'balances', 'activity', 'pcf'],
        group: ['holdings', 'balances', 'activity', 'pcf'],
        client: ['holdings', 'balances', 'activity', 'pcf'],
        'security-equity': [
            'holdings-by-symbol',
            'dividend-reinvestment',
            'disposition-method',
            'periodic-instructions',
            'account-activity',
            'divider',
            'ots-rollover-activity',
            'cfra-quickview',
            'security-news',
            'chart',
            'historical-price',
            'divider',
            'trade-buy-more-equity',
            'holdings-buy-more-equity',
            'trade-sell-positions',
            'trade-sell-covered',
            'trade-sell-covered-options',
            'trade-sell-all-equity',
            'trade-sell-short',
            'trade-buy-to-cover',
            'divider',
            'account-note',
        ],
        'security-etf': [
            'holdings-by-symbol',
            'dividend-reinvestment',
            'disposition-method',
            'periodic-instructions',
            'account-activity',
            'divider',
            'ots-rollover-activity',
            'cfra-quickview',
            'security-news',
            'chart',
            'historical-price',
            'divider',
            'trade-buy-more-equity',
            'holdings-buy-more-equity',
            'trade-sell-positions',
            'trade-sell-covered',
            'trade-sell-covered-options',
            'trade-sell-all-equity',
            'trade-sell-short',
            'trade-buy-to-cover',
            'divider',
            'account-note',
        ],
        'security-mutfund': [
            'holdings-by-symbol',
            'dividend-reinvestment',
            'disposition-method',
            'periodic-instructions',
            'account-activity',
            'divider',
            'ots-rollover-activity',
            'calculate-loiroa',
            'calculate-cdsc',
            'cfra-quickview',
            'security-news',
            'chart',
            'historical-price',
            'divider',
            'trade-buy-mf',
            'trade-buy-mf-529plan',
            'trade-redeem',
            'trade-redeem-all',
            'trade-redeem-mf-529plan',
            'trade-redeem-all-mf-529plan',
            'trade-exchange',
            'trade-exchange-all',
            'trade-exchange-mf-529plan',
            'trade-exchange-all-mf-529plan',
            'divider',
            'account-note',
        ],
        'security-option': [
            'holdings-by-symbol',
            'disposition-method',
            'periodic-instructions',
            'account-activity',
            'divider',
            'security-news',
            'divider',
            'trade-buy-calls-to-open',
            'trade-sell-calls-to-open',
            'trade-buy-puts-to-open',
            'trade-sell-puts-to-open',
            'trade-close-calls-puts',
            'trade-roll',
            'divider',
            'account-note',
        ],
        'security-fixedincome': [
            'holdings-by-symbol',
            'disposition-method',
            'account-activity',
            'divider',
            'sell-from-holdings',
            'divider',
            'account-note',
        ],
        'security-common': ['holdings-by-symbol', 'divider', 'account-note'],
        'security-group': ['quotes', 'sell-positions'],
        'holdings-ibdoffip': [
            'view-accounts',
            'view-iptotals',
            'quotes',
            'investment-center',
        ],
    }; }
}

/**
 * @desc interacts with the back-end services to get the list of applicable action menus for an user
 */
class ActionMenuService {
    constructor(logService, authorizationService) {
        this.logService = logService;
        this.authorizationService = authorizationService;
        this.menudIdName = 'menuId';
    }
    /*
        Function that process the menu config with entitlements and flags and returns the list of menus to display
    */
    getActionMenuList(context, actionMenuFlags, featureMenus) {
        let type;
        let enabledFlag = true;
        const roleName = 'role';
        /* Use the key or the context type/subtype/status to determine which menu items to display. */
        /* Key takes precedence over context as key is supposed to be used for special usecases. */
        if (context.key && context.key !== '') {
            type = context.key;
        }
        else {
            if (context.type && context.type !== '') {
                type = context.type;
                if (context.status && context.status.length > 0) {
                    type = type + '-' + context.status;
                }
                else if (context.subtype && context.subtype !== '') {
                    type = type + '-' + context.subtype;
                }
            }
        }
        /* Merge repeat menu entries */
        const additionalMenuConfig = NxpActionMenuConfig.NXP_ACTION_MENU_DUPLICATE_MAPPING;
        if (additionalMenuConfig) {
            additionalMenuConfig.forEach((value, key) => {
                if (value && key) {
                    if (NxpActionMenuConfig.NXP_ACTION_MENU_CONFIG[value]) {
                        NxpActionMenuConfig.NXP_ACTION_MENU_CONFIG[key] = NxpActionMenuConfig.NXP_ACTION_MENU_CONFIG[value];
                    }
                }
            });
        }
        this.actionMenuList = []; // Menu items to display for the give inputs
        let menus;
        menus = NxpActionMenuConfig.NXP_ACTION_MENU_CONFIG[type]; // All the menus from the config
        /*
        For Securities, there are multiple asset classes and except 4, others will only have one item in the action menu.
        For them instead of defining their own menu, it would be better to have one common menu.
        So check for <type>-common if a menu is not available for the specific assettype.
        */
        if (!menus || menus.length === 0) {
            let commonType = context.type;
            if (commonType && commonType.length > 0) {
                commonType = commonType.concat('-common');
                menus = NxpActionMenuConfig.NXP_ACTION_MENU_CONFIG[commonType];
            }
        }
        let menuListIndex = 0;
        if (menus && menus.length > 0) {
            for (let i = 0; i < menus.length; i++) {
                enabledFlag = true;
                const menuCandidate = NxpActionMenuConfig.NXP_ACTION_MENU_MASTER[menus[i]];
                /* Check if the meni ID listed in menu is available in the menu item definition and proceed */
                if (menuCandidate) {
                    if (menuCandidate.disabled) {
                        enabledFlag = false;
                        /*
                        There can be cases where the feature menus may need to be added among other menus instead of top.
                        For these cases, we define the menu with disabled state and add them to menu list.
                        The feature team can pass an include flag as in <menuId>-include in the ActionMenuFlags based on which
                        the menus will be enabled.
                        */
                        if (actionMenuFlags && actionMenuFlags.length > 0) {
                            const menuId = menuCandidate[this.menudIdName];
                            const flag = menuCandidate.flag ? menuCandidate.flag : menuId.concat('-include');
                            const isFound = actionMenuFlags.indexOf(flag);
                            if (isFound !== -1) {
                                enabledFlag = true;
                            }
                        }
                    }
                    else {
                        /*
                            The component can supply a list of flags to hide certain menus that are not applicable
                            either for the component or for a specific usecase.
                            The flag name could either be configured explicitly or the menu item's ID suffixed with "-exclude" implicitly.
                            For examaple, if you do not want to have Balances, then pass the flag as balances-flag. Preferred is implicit.
                            The flags can also be used for other behavior tweaks later where the menu behaviors can be modified based on
                            additional flags that are not tied to the menu names.
                        */
                        if (actionMenuFlags && actionMenuFlags.length > 0) {
                            /* First check if any menu items need to be excluded */
                            const menuId = menuCandidate[this.menudIdName];
                            const flag = menuCandidate.flag ? menuCandidate.flag : menuId.concat('-exclude');
                            // const isFound = actionMenuFlags.findIndex(element => element === flag); // Removed due to IE compatibility
                            const isFound = actionMenuFlags.indexOf(flag);
                            if (isFound !== -1) {
                                enabledFlag = false;
                            }
                        }
                    }
                    /* Check if the user is entitled to the role */
                    if (menuCandidate.role && menuCandidate.role !== '') {
                        const role = menuCandidate[roleName];
                        if (!this.authorizationService.isEntitled(role)) {
                            enabledFlag = false;
                        }
                    }
                    if (enabledFlag) {
                        this.actionMenuList[menuListIndex] = menuCandidate;
                        menuListIndex++;
                        if (!menuCandidate.isDivider) {
                            menuCandidate.isDivider = false;
                        }
                    }
                }
                else {
                    this.logService.error('Action Menu: Menu is not defined ' + menus[i]);
                }
            }
        }
        else {
            this.logService.error('Action Menu: No menu item is defined for the context info passed. Review your configuration/data.', type);
        }
        this.actionMenuList = this.updateDividers(this.actionMenuList);
        return this.actionMenuList;
    }
    /*
        Removed unnecessary dividers.
        After processing the menu config with entitlements and flags, dividers may be inappropriately placed - at top or bottom, consecutive
        This function removes such invalid Dividers
    */
    updateDividers(actionMenus) {
        if (actionMenus.length > 0) {
            /* Delete duplicate, consecutive dividers */
            if (actionMenus.length > 1) {
                for (let i = 1; i < actionMenus.length; i++) {
                    if (actionMenus[i - 1] && actionMenus[i - 1].isDivider &&
                        actionMenus[i] && actionMenus[i].isDivider) {
                        actionMenus.splice(i, 1);
                    }
                }
            }
            /* Delete if the first menu is a divider */
            if (actionMenus[0] && actionMenus[0].isDivider) {
                actionMenus.splice(0, 1);
            }
            /* Delete if the last menu is a divider */
            const lastIndex = actionMenus.length - 1;
            if (actionMenus[lastIndex] && actionMenus[lastIndex].isDivider) {
                actionMenus.splice(lastIndex, 1);
            }
        }
        return actionMenus;
    }
    /*  Below function is not needed except if we display the context value
        on the menu and allow the user to click it */
    handleContextClick(type, value) {
        /* There are cases where the action menu will need to pass back and event to the component
            instead of invoking navigation. This also need to be handled. */
        // this.navigationService.navigateOnContext(type, value);  // Publish an event instead
        document.dispatchEvent(new CustomEvent("navigateOnContext", { detail: { type: type, value: value } }));
    }
    handleActionMenuClick(type, value, target) {
        // this.logService.info('Action Menu click handler : ', type, value, target);
        // this.navigationService.navigateOnAction(type, value, target); // Publish an event instead
        document.dispatchEvent(new CustomEvent("navigateOnAction", { detail: { type: type, value: value, target: target } }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionMenuService, deps: [{ token: i1.LogService }, { token: i1.PermissionCheckerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionMenuService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ActionMenuService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.LogService }, { type: i1.PermissionCheckerService }]; } });

/**
 *  @file nxp-modal.service.ts
 *  @since 21-Aug-2017
 */
/**
 * @desc     This service should be injected by the components that will launch a modal dialog
 *           with a dynamically loaded component
 * @howToUse The components need to call the openDialog() property with the component that should be
 *            loaded inside the dialog
 */
class PershingModalService {
    constructor() {
        this._modalProperties = new Subject();
        this.modalProperties$ = this._modalProperties.asObservable();
        this._hasConfirmedModal = new BehaviorSubject(false);
        this.hasConfirmedModal$ = this._hasConfirmedModal.asObservable();
    }
    /**
     * @param component
     */
    openPershingModal(dynamicComponent, modalConfig) {
        this._modalProperties.next({
            component: dynamicComponent,
            modalConfig: modalConfig,
        });
    }
    closePershingModal(id) {
        let isDialogClosed = false;
        this._dialogRef.close();
        this._dialogRef.afterClosed().subscribe((result) => {
            isDialogClosed = result ? true : false;
        });
        return isDialogClosed;
    }
    set dialogRef(dialogRef) {
        this._dialogRef = dialogRef;
    }
    setConfirmationModal(value) {
        this._hasConfirmedModal.next(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingModalService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingModalService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingModalService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });
class PershingModalProperties {
}

class Content {
}

/* TODO: Check if the context types from context service can be used here */
class ActionMenuContext {
}

class PershingModalConfig {
    constructor() {
        /** Whether the dialog can be closed by clicking outside the dialog or ESC key */
        this.disableClose = false;
        /** style class for the dialog */
        this.panelClass = 'modal';
    }
}

class MockActionMenuService {
    getActionMenuList(context) { return []; }
    handleContextClick(type, value) { }
    handleActionMenuClick(type, value, target) { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MockActionMenuService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MockActionMenuService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MockActionMenuService, decorators: [{
            type: Injectable
        }] });

const rolesData = {
    'entitlements': [
        {
            'entitlementIdentifer': '100',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '101',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': true, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '121',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '259',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '258',
            'allowRead': true, 'allowUpdate': false,
            'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '101',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '102',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '105',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '106',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '107',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '123',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': 'BAD',
            'allowRead': false, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        }
    ]
};

const MOCK_MENUITEAM = {
    values: [{
            id: 'my-practice',
            name: 'My Practice',
            entitlements: [],
            children: [
                {
                    id: 'lists',
                    name: 'Lists',
                    entitlements: [],
                    children: [
                        {
                            id: 'households',
                            name: 'Households',
                            entitlements: []
                        },
                        {
                            id: 'clients',
                            name: 'Clients',
                            entitlements: [],
                            children: []
                        }
                    ]
                },
                {
                    id: 'details',
                    name: 'Details',
                    entitlements: [],
                    children: [
                        {
                            id: 'holdings',
                            name: 'Holdings',
                            entitlements: [],
                            children: [
                                {
                                    id: 'positions',
                                    name: 'Positions',
                                    entitlements: []
                                },
                                {
                                    id: 'gains-losses',
                                    name: 'Gains/Losses',
                                    entitlements: []
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: 'operations',
            name: 'Operations',
            entitlements: [],
            children: []
        },
        {
            id: 'analytics',
            name: 'Analytics & Reporting',
            entitlements: [],
            children: []
        }
    ]
};

class MessagingConstants {
    static { this.DISPLAYTYPE_INPAGE = 'inpage'; }
    static { this.DISPLAYTYPE_MODAL = 'modal'; }
    static { this.MESSAGETYPE_INFO = 'info'; }
    static { this.MESSAGETYPE_CONFIRM = 'confirm'; }
    static { this.MESSAGETYPE_WARN = 'warn'; }
    static { this.MESSAGETYPE_ERROR = 'error'; }
    static { this.MESSAGETYPE_TIP = 'tip'; }
    static { this.MODAL_WIDTH = '350px'; }
    static { this.MESSAGE_COLOR_CONFIRM = 'positive'; }
    static { this.MESSAGE_COLOR_INFO = 'information'; }
    static { this.MESSAGE_COLOR_WARNING = 'warning'; }
    static { this.MESSAGE_COLOR_ERROR = 'negative'; }
    static { this.MESSAGETYPE_COLOR_TIP = 'information'; }
    static { this.CONFIRM_MESSAGE_ICON = 'fa-check-circle'; }
    static { this.INFO_MESSAGE_ICON = 'fa-info-circle'; }
    static { this.WARNING_MESSAGE_ICON = 'fa-exclamation-triangle'; }
    static { this.ERROR_MESSAGE_ICON = 'fa-exclamation-circle'; }
    static { this.ACTION_BUTTON_LABEL = 'OK'; }
    static { this.TIP_MESSAGE_ICON = 'fa-lightbulb'; }
    // Overlay
    static { this.PERSHING_OVERLAY_CONFIG = 'pershing-overlay-configuration'; }
    static { this.OVERLAY_LOADING_EVENT = 'overlay-loading-event'; }
    static { this.OVERLAY_LOADING_COMPLETE_EVENT = 'overlay-loading-complete-event'; }
}

class LoginComponent {
    constructor(authenticationService, logger) {
        this.authenticationService = authenticationService;
        this.logger = logger;
    }
    ngOnInit() {
        //constructor is left blank intentionally
    }
    login(userIdElement, passwordElement) {
        this.authenticationService.authenticate(userIdElement.value.toUpperCase(), passwordElement.value)
            .then(response => {
            if (response === 0) {
                this.errorMessage = null;
            }
            else if (response === 1) {
                this.errorMessage = 'Invalid Password';
            }
            else if (response === 2) {
                this.errorMessage = 'Invalid User ID';
            }
            else {
                this.errorMessage = 'System error occurred. Please try again later.';
            }
        })
            .catch(this.handleError);
    }
    logout() {
        this.authenticationService.logout();
    }
    isLoggedIn() {
        return this.authenticationService.isLoggedIn();
    }
    handleError(error) {
        this.logger.error('Error: ', error);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoginComponent, deps: [{ token: i1.AuthenticationService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LoginComponent, selector: "nxp-login", ngImport: i0, template: "<p>Login</p>\n\n<div *ngIf=\"!isLoggedIn(); else loading\">\n    <form (ngSubmit)=\"login(userId, password)\" autocomplete=\"off\">\n        <input #userId type=\"text\" id=\"userId\" placeholder=\"User ID\" required>\n\n        <input #password type=\"password\" id=\"password\" placeholder=\"Password\" required>\n\n        <button type=\"submit\">Submit</button>\n    </form>\n</div>\n\n<div *ngIf=\"errorMessage\">\n    <p class=\"error-msg\">{{ errorMessage }}</p>\n</div>\n\n<ng-template #loading>\n    <p class=\"success-msg\">Successful login!</p>\n    <button type=\"button\" (click)=\"logout()\">Log Out</button>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LoginComponent, decorators: [{
            type: Component,
            args: [{ selector: 'nxp-login', template: "<p>Login</p>\n\n<div *ngIf=\"!isLoggedIn(); else loading\">\n    <form (ngSubmit)=\"login(userId, password)\" autocomplete=\"off\">\n        <input #userId type=\"text\" id=\"userId\" placeholder=\"User ID\" required>\n\n        <input #password type=\"password\" id=\"password\" placeholder=\"Password\" required>\n\n        <button type=\"submit\">Submit</button>\n    </form>\n</div>\n\n<div *ngIf=\"errorMessage\">\n    <p class=\"error-msg\">{{ errorMessage }}</p>\n</div>\n\n<ng-template #loading>\n    <p class=\"success-msg\">Successful login!</p>\n    <button type=\"button\" (click)=\"logout()\">Log Out</button>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i1.AuthenticationService }, { type: i1.LogService }]; } });

class NxpActionMenuComponent {
    constructor(actionMenuService, translate, logService) {
        this.actionMenuService = actionMenuService;
        this.translate = translate;
        this.logService = logService;
        this.actionMenuSelectEmitter = new EventEmitter();
        this.divider = [NxpActionMenuConfig.NXP_ACTION_MENU_MASTER.divider];
        this.newWindowTooltip = ActionMenuLabels.OPEN_IN_NEW_TAB;
        this.elementId = null;
        this.isPopoutHoverOn = false;
        this.translate.addTranslationFolder('@pershing/pershing-common', 'node_modules/@pershing/pershing-common/lib');
    }
    ngOnInit() {
        this.initiateMenus();
    }
    initiateMenus() {
        /*  If payload contains the context data, populate it in actionMenuContext */
        if (this.context) {
            this.menuContext = this.context;
        }
        else {
            this.menuContext.type = this.payload.contextType
                ? this.payload.contextType
                : null;
            this.menuContext.subtype = this.payload.contextSubtype
                ? this.payload.contextSubtype
                : null;
            this.menuContext.status = this.payload.contextStatus
                ? this.payload.contextStatus
                : null;
            this.menuContext.actionMenuFlags = this.payload.actionMenuFlags
                ? this.payload.actionMenuFlags
                : null;
            this.menuContext.key = this.payload.actionMenuKey
                ? this.payload.actionMenuKey
                : null;
            this.menuContext.value = this.payload.contextValue
                ? this.payload.contextValue
                : null;
        }
        if (!this.menuContext.key || this.menuContext.key.length === 0) {
            if (this.menuContext && this.menuContext.type) {
                this.menuContext.type = this.menuContext.type.toLowerCase().trim();
                if (this.menuContext.subtype) {
                    this.menuContext.subtype = this.menuContext.subtype
                        .toLowerCase()
                        .trim();
                    this.menuContext.subtype = this.menuContext.subtype.replace(' ', '');
                }
            }
            else {
                this.logService.error('Invalid context data is supplied. Exiting ...');
                return;
            }
        }
        /* Get the list of action menus from the action menu meta data based on the context type and flags */
        this.actionMenuList = this.actionMenuService.getActionMenuList(this.menuContext, this.menuContext.actionMenuFlags, this.featureMenus);
        /* If the feature needs custom action menus specific to itself, then add them on top of standard menus */
        /* The feature specific menus should be supplied by the feature itself using the same object structure */
        /* For feature menus, the entitlement check should be done by features */
        /* Merge the standard action menus and the feature menus. Put the feature menus at the top */
        if (this.featureMenus != null && this.featureMenus.length > 0) {
            /*
                      Handle disabled flag for feature menus.
                      If disabled flag is true, then do not add the menu item.
                      If feature menu is available in actionMenuList, then remove from feature menu list
                  */
            this.featureMenus = this.featureMenus.filter((featureMenu) => featureMenu.disabled !== true &&
                this.actionMenuList.findIndex((actionMenu) => actionMenu.menuId === featureMenu.menuId) < 0);
            if (this.actionMenuList && this.actionMenuList.length > 0) {
                this.actionMenuList = [
                    ...this.featureMenus,
                    ...this.divider,
                    ...this.actionMenuList,
                ];
            }
            else {
                this.actionMenuList = this.featureMenus;
            }
        }
    }
    openFeatureInNewWindow(event, menuId) {
        this.selectMenuAction(menuId, true);
        event.stopImmediatePropagation();
    }
    selectMenuAction(menuId, openInNewWindow) {
        const selectedMenu = this.actionMenuList.find((element) => element.menuId === menuId);
        if (!selectedMenu) {
            this.logService.error('Action Menu: Selected menu is not found in menu list. Unknown error.');
            return;
        }
        this.handleMenuAction(selectedMenu, openInNewWindow); // Delegate processing to a diff function for nit testing
    }
    showPopoutIcon(id) {
        this.elementId = id;
    }
    hidePopoutIcon() {
        this.elementId = null;
    }
    handleMenuAction(selectedMenu, openInNewWindow) {
        let params;
        let actionMenuEvent;
        let menuId;
        let parameterString;
        const parameterArray = new Array();
        let navTarget;
        /*
                Below is the old implementation that calls the service to initiate the navigation.
                But the navigaiton should be happening through events instead of calling navigationservice. */
        // this.actionMenuService.handleActionMenuClick(this.context.type, this.context.value, menuId);
        menuId = selectedMenu.menuId;
        if (selectedMenu.gotoPage) {
            navTarget = selectedMenu.gotoPage;
        }
        else {
            navTarget = '';
            this.logService.warn('No gotoPage is present in the selected ment - selectedMenu.gotoPage is null/undefined !');
        }
        /* Get the target page and params */
        params = this.getTargetPageAndParam(params, menuId);
        /* Get context type and value */
        /*
            The domain context is meant for target application and not for the menu.
            So it has be defined/manages separately without mixing it with the type/subtype passed to identify menu items.
            */
        /* If the menu is defined with a domain context type, then use it. If not, base it off the context type passed */
        /* If the selected menu has its own domain, then pick the corresponding context value from payload */
        this.getContextTypeAndValue(selectedMenu);
        /* Prepare the params */
        const urlParams = new Map();
        if (selectedMenu.payloadMetadata) {
            if (selectedMenu.payloadMetadata.params) {
                this.prepareParams(selectedMenu, params, urlParams);
            }
        }
        if (urlParams && urlParams.size > 0) {
            // parameterString = urlParams.toString();
            urlParams.forEach((mapValue, mapKey) => {
                parameterArray.push(mapKey + '=' + mapValue);
            });
            parameterString = parameterArray.join('&');
        }
        //below condition is for launching the menu in new window and skip further flow
        if (openInNewWindow) {
            this.openInNewWindow({
                source: 'action-menu-' + menuId,
                gotoPage: navTarget,
                gotoParam: parameterString,
                domain: this.domain,
                value: this.value,
            });
            return;
        }
        // this.logService.log('Action Menu - Params: ', params);
        /*
                There are 3 ways the selected action will be handled.
                1. Output of ActionMenu through the EventEmitter - Component can make use of this if they do not want to use CustomEvent.
                2. If a callbackEvent is passed, then publish a custom event with the label supplied.
                3. A custom event for "portal.gotoview" to offload the initiation of naigation to portal with the payload.
    
                Both 1 & 2 passes the selected menu ID and the parameters from Payload as event payload.
                3 has additional items in payload to support navigation.
    
            /* If component has requested for an event call back, create and publish the event. */
        const eventEmitterPayload = {
            selectedMenu: menuId,
            parameters: parameterString,
            gotoParams: parameterString,
            payload: this.payload,
        };
        /* TODO: Decide which value to return */
        if (selectedMenu.callbackEvent) {
            /* Pass the payload as an event */
            actionMenuEvent = new CustomEvent(selectedMenu.callbackEvent, {
                detail: {
                    selectedMenu: menuId,
                    parameters: parameterString,
                    gotoParams: parameterString,
                    payload: this.payload,
                },
            });
            document.dispatchEvent(actionMenuEvent);
            this.actionMenuSelectEmitter.emit(eventEmitterPayload); // Emit an event. Global Search uses this to close itself.
            return;
        }
        /* If a navigation target is avaialble, then publish a portal.gotoview event */
        if (navTarget && navTarget.length > 0) {
            actionMenuEvent = new CustomEvent('portal.gotoview', {
                detail: {
                    selectedMenu: menuId,
                    domain: this.domain,
                    value: this.value,
                    gotoPage: navTarget,
                    parameters: parameterString,
                    gotoParams: parameterString,
                },
            });
            /* log the event this is raising */
            this.logService.info('In nxp-action-menu component: handleMenuAction() actionMenuEvent = ', actionMenuEvent);
            document.dispatchEvent(actionMenuEvent);
            this.actionMenuSelectEmitter.emit(eventEmitterPayload); // Emit an event. Global Search uses this to close itself.
            return;
        }
        /*
                if neither a target is provided nor a custom event is supplied, it means that the component
                would handled the output. So let us use EventEmitter to provide the selected menu ID and
                params to the components.
            */
        this.actionMenuSelectEmitter.emit(eventEmitterPayload);
        return;
    }
    prepareParams(selectedMenu, params, urlParams) {
        const paramsList = selectedMenu.payloadMetadata.params.split(',');
        let paramValue;
        paramsList.forEach((element) => {
            element = element.trim();
            if (element.indexOf('=') !== -1) {
                const paramsArray = element.split('=');
                paramValue = this.setParam(paramsArray, params, paramValue, urlParams);
            }
            else {
                if (params && params[element]) {
                    urlParams.set(element, params[element]);
                }
            }
        });
    }
    setParam(paramsArray, params, paramValue, urlParams) {
        if (paramsArray && paramsArray.length === 2) {
            /*
                          For cases where the parameter name that needs to be passed to target application and the
                          attribute coming from the component are different, we indicate the value with {}.
      
                          Eg: qty={quantity} - qty is the parameter that target expects whereas the component model has it as quantity.
      
                          For these cases, take the name within the paranthesis and try to find if the incoming payload
                          has the value for this attribute and pack it.
                          */
            if (paramsArray[1].indexOf('{') !== -1 &&
                paramsArray[1].indexOf('}') !== -1) {
                const paramName = paramsArray[1].substring(1, paramsArray[1].length - 1);
                if (params && params[paramName]) {
                    paramValue = params[paramName];
                }
            }
            else {
                paramValue = paramsArray[1];
            }
            urlParams.set(paramsArray[0], paramValue);
        }
        else {
            this.logService.error('Action Menu: Erroneos payload metadata configuration. Check and correct.');
        }
        return paramValue;
    }
    getContextTypeAndValue(selectedMenu) {
        if (selectedMenu.domain) {
            this.domain = selectedMenu.domain;
            /*
                  Pick the domain context value from payload.value as default action and for backward compatibility
                  so that we do not need any changes from the components that do not support multiple context types
                  in action menu.
                  */
            if (this.payload?.value) {
                this.value = this.payload.value;
            }
            /*
                      Overwrite the domain context value if a different domain context value is passed.
                      This is needed only when a multiple domains are supported and the selected menu requires
                      a different context than the primary context.
                      For example, most context menus are off account context, so if the value passed in payload
                      is of AccountContext type, then there is no need to pass accountDomainValue. But, when Quotes
                      menu is selected, then we need securityDomainValue.
                  */
            this.getDomainContextValue();
        }
        else if (this.menuContext.type) {
            this.domain = this.menuContext.type.toLowerCase();
            /* Get the value from the action menu context value attribute */
            if (this.menuContext.value) {
                this.value = this.menuContext.value;
            }
        }
    }
    getDomainContextValue() {
        if (this.domain === 'security' && this.payload.securityDomainValue) {
            this.value = this.payload.securityDomainValue;
        }
        else if (this.domain === 'account' && this.payload.accountDomainValue) {
            this.value = this.payload.accountDomainValue;
        }
        else if (this.domain === 'ibdoffip' && this.payload.ibdOffIpDomainValue) {
            this.value = this.payload.ibdOffIpDomainValue;
        }
        else if (this.domain === 'household' &&
            this.payload.householdDomainValue) {
            this.value = this.payload.householdDomainValue;
        }
        else if (this.domain === 'group' && this.payload.groupDomainValue) {
            this.value = this.payload.groupDomainValue;
        }
    }
    getTargetPageAndParam(params, menuId) {
        if (this.payload) {
            if (this.payload.gotoParams) {
                params = [];
                const paramString = this.payload.gotoParams;
                const ParamValueArray = paramString.split('&');
                ParamValueArray.forEach((paramElement) => {
                    const paramArray = paramElement.split('=');
                    params[paramArray[0]] = paramArray[1];
                });
            }
            else {
                params = this.payload;
            }
        }
        if (params &&
            this.isOptionActionMenu(menuId) &&
            !params.rootId &&
            params.symId) {
            params['rootId'] = this.getOptionSymbolId(params.symId);
        }
        return params;
    }
    openInNewWindow(newWindowParams) {
        const newwindowevent = new CustomEvent('portal.openFeatureInMultitab', {
            bubbles: true,
            detail: {
                source: newWindowParams.source,
                data: {
                    detail: {
                        gotoPage: newWindowParams.gotoPage,
                        domain: newWindowParams.domain,
                        value: newWindowParams.value,
                        gotoParams: newWindowParams.gotoParam,
                    },
                    action: 'multitask',
                    multiTabConfig: {
                        openIn: 'NEW_TAB',
                    },
                },
            },
        });
        document.dispatchEvent(newwindowevent);
    }
    isOptionActionMenu(menuId) {
        const optionMenu = NxpActionMenuConfig.NXP_ACTION_MENU_CONFIG['security-option'].find((x) => x === menuId);
        if (optionMenu) {
            return true;
        }
        return false;
    }
    getOptionSymbolId(symId) {
        const paramsArray = symId.split(' ');
        if (paramsArray && paramsArray.length > 1) {
            return paramsArray[0];
        }
        return symId;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxpActionMenuComponent, deps: [{ token: ActionMenuService }, { token: i1.PershingTranslationService }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: NxpActionMenuComponent, selector: "nxp-action-menu", inputs: { context: "context", payload: "payload", featureMenus: "featureMenus" }, outputs: { actionMenuSelectEmitter: "actionMenuSelectEmitter" }, providers: [ActionMenuService], ngImport: i0, template: "<div class=\"actionMenuContainer\">\n  <div *ngIf=\"actionMenuList && actionMenuList.length > 0\">\n    <button\n      mat-icon-button\n      class=\"dropdown-menu\"\n      [matMenuTriggerFor]=\"actions\"\n      tabindex=\"0\"\n    >\n      <mat-icon class=\"far fa-lg fa-caret-circle-down\"></mat-icon>\n    </button>\n    <mat-menu #actions=\"matMenu\" [overlapTrigger]=\"false\">\n      <ng-container *ngFor=\"let actionMenuItem of actionMenuList\">\n          <button mat-menu-item\n                  *ngIf=\"actionMenuItem !== undefined && (actionMenuItem.isDivider === undefined ||  actionMenuItem.isDivider === false)\"\n                  (mouseover)=\"showPopoutIcon(actionMenuItem.menuId)\" (mouseout)=\"hidePopoutIcon()\"\n                  (click)=\"selectMenuAction(actionMenuItem.menuId)\">\n              {{ actionMenuItem.menuLabel | translate }}&nbsp;\n              <i *ngIf=\"actionMenuItem.enableMultitabPopout\"\n                 [ngClass]=\"{'fa-regular': !isPopoutHoverOn, 'fa-solid': isPopoutHoverOn,'text-link fa-external-link-square-alt':actionMenuItem.menuId === elementId}\"\n                 class=\"text-link fa-external-link-square-alt\" (mouseenter)=\"isPopoutHoverOn = true\"\n                 (mouseleave)=\"isPopoutHoverOn = false\"\n                 (click)=\"openFeatureInNewWindow($event,actionMenuItem.menuId)\"\n                 matTooltip={{newWindowTooltip|translate}} matTooltipPosition=\"right\" aria-hidden=\"true\"></i>\n          </button>\n        <mat-divider\n          *ngIf=\"actionMenuItem !== undefined && actionMenuItem.isDivider\"\n        ></mat-divider>\n      </ng-container>\n    </mat-menu>\n  </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i5.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "component", type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i7.MatLegacyMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i7.MatLegacyMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i7.MatLegacyMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i8.MatLegacyTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i9.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NxpActionMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'nxp-action-menu', providers: [ActionMenuService], template: "<div class=\"actionMenuContainer\">\n  <div *ngIf=\"actionMenuList && actionMenuList.length > 0\">\n    <button\n      mat-icon-button\n      class=\"dropdown-menu\"\n      [matMenuTriggerFor]=\"actions\"\n      tabindex=\"0\"\n    >\n      <mat-icon class=\"far fa-lg fa-caret-circle-down\"></mat-icon>\n    </button>\n    <mat-menu #actions=\"matMenu\" [overlapTrigger]=\"false\">\n      <ng-container *ngFor=\"let actionMenuItem of actionMenuList\">\n          <button mat-menu-item\n                  *ngIf=\"actionMenuItem !== undefined && (actionMenuItem.isDivider === undefined ||  actionMenuItem.isDivider === false)\"\n                  (mouseover)=\"showPopoutIcon(actionMenuItem.menuId)\" (mouseout)=\"hidePopoutIcon()\"\n                  (click)=\"selectMenuAction(actionMenuItem.menuId)\">\n              {{ actionMenuItem.menuLabel | translate }}&nbsp;\n              <i *ngIf=\"actionMenuItem.enableMultitabPopout\"\n                 [ngClass]=\"{'fa-regular': !isPopoutHoverOn, 'fa-solid': isPopoutHoverOn,'text-link fa-external-link-square-alt':actionMenuItem.menuId === elementId}\"\n                 class=\"text-link fa-external-link-square-alt\" (mouseenter)=\"isPopoutHoverOn = true\"\n                 (mouseleave)=\"isPopoutHoverOn = false\"\n                 (click)=\"openFeatureInNewWindow($event,actionMenuItem.menuId)\"\n                 matTooltip={{newWindowTooltip|translate}} matTooltipPosition=\"right\" aria-hidden=\"true\"></i>\n          </button>\n        <mat-divider\n          *ngIf=\"actionMenuItem !== undefined && actionMenuItem.isDivider\"\n        ></mat-divider>\n      </ng-container>\n    </mat-menu>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: ActionMenuService }, { type: i1.PershingTranslationService }, { type: i1.LogService }]; }, propDecorators: { context: [{
                type: Input
            }], payload: [{
                type: Input
            }], featureMenus: [{
                type: Input
            }], actionMenuSelectEmitter: [{
                type: Output
            }] } });

class PershingDisclaimerComponent {
    constructor() {
        this.showExpansion = true;
        this.showContent = true;
        this.isExpanded = false;
    }
    ngOnInit() {
        if (this.disclaimers == null && this.disclosures == null) {
            this.showContent = !this.showContent;
        }
    }
    toggleExpansion() {
        return this.showExpansion = !this.showExpansion;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingDisclaimerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingDisclaimerComponent, selector: "pershing-disclaimer", inputs: { disclaimers: "disclaimers", disclosures: "disclosures", isExpanded: "isExpanded" }, ngImport: i0, template: "<mat-expansion-panel *ngIf=\"showContent\" class=\"mat-elevation-z0 fw-Disclaimers\" hideToggle=\"true\" [expanded]=\"isExpanded\">\n\n    <mat-expansion-panel-header class=\"headerPadding\" (click)=\"toggleExpansion()\"  [expandedHeight]=\"'16px'\" [collapsedHeight]=\"'16px'\">\n        <a><mat-icon class=\"fal\" [ngClass]=\"{'fa-chevron-right': showExpansion, 'fa-chevron-up': !showExpansion}\"></mat-icon>\n        Disclaimers & Disclosures</a>\n    </mat-expansion-panel-header>\n\n    <mat-panel-description>\n        <div class=\"margin-top-10\" *ngIf=\"disclaimers\">\n        <strong>Disclaimers</strong>\n        <p *ngFor=\"let values of disclaimers\" [innerHTML]=\"values\" class=\"fw-Disclaimers_Content\"></p>\n        </div>\n    </mat-panel-description>\n       <mat-panel-description>\n        <div *ngIf=\"disclosures\">\n        <strong>Disclosures</strong>\n        <p *ngFor=\"let values of disclosures\" [innerHTML]=\"values\" class=\"fw-Disclaimers_Content\"></p>\n        </div>\n    </mat-panel-description>\n\n</mat-expansion-panel>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i2$1.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i2$1.MatExpansionPanelDescription, selector: "mat-panel-description" }, { kind: "component", type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingDisclaimerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-disclaimer', template: "<mat-expansion-panel *ngIf=\"showContent\" class=\"mat-elevation-z0 fw-Disclaimers\" hideToggle=\"true\" [expanded]=\"isExpanded\">\n\n    <mat-expansion-panel-header class=\"headerPadding\" (click)=\"toggleExpansion()\"  [expandedHeight]=\"'16px'\" [collapsedHeight]=\"'16px'\">\n        <a><mat-icon class=\"fal\" [ngClass]=\"{'fa-chevron-right': showExpansion, 'fa-chevron-up': !showExpansion}\"></mat-icon>\n        Disclaimers & Disclosures</a>\n    </mat-expansion-panel-header>\n\n    <mat-panel-description>\n        <div class=\"margin-top-10\" *ngIf=\"disclaimers\">\n        <strong>Disclaimers</strong>\n        <p *ngFor=\"let values of disclaimers\" [innerHTML]=\"values\" class=\"fw-Disclaimers_Content\"></p>\n        </div>\n    </mat-panel-description>\n       <mat-panel-description>\n        <div *ngIf=\"disclosures\">\n        <strong>Disclosures</strong>\n        <p *ngFor=\"let values of disclosures\" [innerHTML]=\"values\" class=\"fw-Disclaimers_Content\"></p>\n        </div>\n    </mat-panel-description>\n\n</mat-expansion-panel>\n" }]
        }], propDecorators: { disclaimers: [{
                type: Input
            }], disclosures: [{
                type: Input
            }], isExpanded: [{
                type: Input
            }] } });

class PershingIFrameComponent {
    set src(newSrc) {
        /*
            Below piece is executed when the src attribute is set programattically.
            For that case, the component that is setting the new src should take care of
            packing appropriate context values.
            Setting params like ${ACCOUNT|accountNumber} will not work.
            */
        const triggerRefresh = this._src !== null;
        this._src = newSrc;
        if (triggerRefresh) {
            this.iframeForm.nativeElement.action = this._src;
            this.iframeForm.nativeElement.submit();
        }
    }
    constructor(renderer, contextService, logService, appSettings) {
        this.renderer = renderer;
        this.contextService = contextService;
        this.logService = logService;
        this.appSettings = appSettings;
        this.options = {};
        this.regionConfig = null;
        this.postMessageEventListener = new EventEmitter();
        this.IFrameElement = {};
        this.$unsubscribe = new Subject();
        this.DEFAULT_HEIGHT = '1000px';
        this.domID = Math.random().toString().replace('.', '');
        this.isLoading = true;
        this._src = null;
        this.initialContextPublishComplete = false;
        this.httpmethod = 'post';
        this.postParams = [];
        this.footerHeight = 70;
        this.noError = true;
    }
    ngOnInit() {
        //region specific support
        if (this.regionConfig) {
            this.updateRegionSpecificSrcOptions();
        }
        this.logService.log('PershingIFrameComponent - ngOnInit() - src - ', this._src, ' : options - ', this.options);
        // with angular elements @input values will be packed as string,
        // so having the below check to parse it back as object
        if (this.options && typeof this.options === 'string') {
            this.options = JSON.parse(this.options);
        }
        if (this.options) {
            this.disableSubsessionIdForSingleton();
            // to support http GET method for needed features - default is POST
            // options : { httpmethod : 'get'} is expected from site-config
            if (this.options.httpmethod &&
                this.options.httpmethod.toLowerCase() === 'get') {
                this.httpmethod = 'get';
                /* Add the params to the URL if the method is HTTP GET - this is not needed as we covert for form fields */
                /*if (this.options.params) {
                            this._src += this.serialize(this.options.params);
                        }*/
            }
        }
        // register on window resize event
        if (this.options.style?.restrictHeightToWindow) {
            this.resizeSub = fromEvent(window, 'resize')
                .pipe(throttleTime(500), debounceTime(500))
                .subscribe(() => this.restrictHeightToWindow());
        }
        if (this.postMessageEventEmitter) {
            this.postMessageSubscription = this.postMessageEventEmitter.subscribe((msg) => {
                this.logService.log(msg);
                // to support for same origin or we can specify the target origin through the options
                if (this.options.postMessageTargetOrigin) {
                    this.IFrameElement.contentWindow.postMessage(msg, this.options.postMessageTargetOrigin);
                }
                else {
                    this.IFrameElement.contentWindow.postMessage(msg, document.domain);
                }
            });
        }
    }
    disableSubsessionIdForSingleton() {
        /** enableSingletonForLegacy flag in PC will be true when the multitab for legacy features need to be disabled
                 when this flag is enabled "true", features will be paired into the singleton groups and subsession id will not be passed (all legacy hits will be reaching parent session from all tabs).  singleton config in menu-config will be overridden by singleton-override config
                 when this flag is pointed to "false", multitab will be enabled for legacy features and subsession id will be passed for the needed apps
                */
        if (this.appSettings?.enableSingletonForLegacy &&
            this.options.params?.subsessionid) {
            delete this.options.params.subsessionid;
        }
    }
    ngAfterViewInit() {
        const iframeAnchorEle = this.iframeAnchor.nativeElement;
        this.generateIframeElement(iframeAnchorEle);
        // Handle context passing to iframe destination url
        const currentContext = this.options.context;
        // check domains are properly configured
        if (currentContext) {
            /* packs both domaincontext and other context user/route context */
            if (this.isSupportedDomainsAvailable(currentContext)) {
                // wait for context to be available and then publish iframe url
                this.contextService.selectedDomainContext$.subscribe((domainContext) => {
                    if (this.isDomainContextAvailable(domainContext)) {
                        this.packContextAndPublish(domainContext);
                    }
                });
            }
            else if (currentContext.otherContext) {
                /* packs only other context user/route context - as domain context not needed*/
                this.packContextAndPublish();
            }
            else {
                /* context config not proper - default case */
                this.logService.error('PershingIFrameComponent - ngAfterViewInit - context not configured properly');
                this.submitUrlAndUpdatePublishState();
            }
        }
        // if loadOnContext false or not available, then do not wait for context to be available before publishing url to iframe
        // check additionally initialContextPublishComplete - to check already iframe published during context subscription
        if ((typeof this.options.loadOnContext === 'undefined' ||
            !this.options.loadOnContext) &&
            !this.initialContextPublishComplete) {
            /*
                      Replaced the call to form.submit() with call to packContextAndPublish
                      so that any context parameters in options.params can be processed correctly
                      after changing the post param values as form fields.
                      While it may not be context sensitive, it may still use UserContext.
                      */
            //this.iframeForm.nativeElement.submit();
            this.packContextAndPublish();
        }
        // get ref HTML element
        this.domElement = this.IFrameElement;
        fromEvent(this.IFrameElement, 'load')
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe((e) => {
            this.isLoading = false;
            this.dispatchCustomEvent('pershingiframe.onload', 'attachEvents', 'PershingIFrameComponent', 'Iframe loading event notification');
            this.IFrameElement.style.display = 'block';
            this.subscribeStylingEvents();
            this.subscribeCustomEvents();
            this.subscribePostMessageEvents();
            this.subscribeClickEvents();
            if (this.options.style?.restrictHeightToWindow) {
                this.restrictHeightToWindow();
            }
        });
    }
    isSupportedDomainsAvailable(currentContext) {
        return (currentContext.supportedDomains &&
            currentContext.supportedDomains.length > 0);
    }
    isDomainContextAvailable(domainContext) {
        return (domainContext != null &&
            domainContext.domain != null &&
            domainContext.value != null);
    }
    restrictHeightToWindow() {
        if (this.domElement) {
            this.domElement.style.minHeight = 'auto';
            const windowHeight = window?.innerHeight;
            const topOffset = this.calcTopOffset();
            let height = windowHeight - (topOffset + this.footerHeight);
            // minHeight needs to be set if the calculated height is very less, can be enhanced based on test result sampling
            this.renderer.setStyle(this.domElement, 'height', `${height}px`);
        }
        else {
            this.logService.error('PershingIFrameComponent - restrictHeightToWindow - domElement is null');
        }
    }
    calcTopOffset() {
        try {
            const rect = this.domElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return rect.top + scrollTop;
        }
        catch (e) {
            return 0;
        }
    }
    subscribeClickEvents() {
        try {
            if (this.IFrameElement.contentWindow &&
                this.IFrameElement.contentWindow.document) {
                fromEvent(this.IFrameElement.contentWindow, 'click')
                    .pipe(takeUntil(this.$unsubscribe))
                    .subscribe((e) => {
                    this.dispatchCustomEvent('portal.iframeEvents', 'idleReset', 'PershingIFrameComponent', 'Iframe click event notification');
                });
            }
        }
        catch (error) {
            this.logService.log('PershingIframeComponent - subscribeClickEvents() - Click Event Listener could not be added.', error);
        }
    }
    dispatchCustomEvent(eventName, action, srcOfOrigin, description, addtionalInfo) {
        let customEvent = new CustomEvent(eventName, {
            bubbles: true,
            detail: {
                source: srcOfOrigin,
                action: action,
                description: description ? description : '',
                additionalInfo: addtionalInfo ? addtionalInfo : null,
            },
        });
        document.dispatchEvent(customEvent);
    }
    subscribeStylingEvents() {
        // if static height (in px or vh) or restrictHeightToWindow true is present in site-config, then iframe auto-resize is suppressed
        if (!this.options.style ||
            (this.options.style &&
                !this.options.style.height &&
                !this.options.style.restrictHeightToWindow)) {
            try {
                // Initialize iframe height to child window
                const windowHeight = this.getContentHeight(this.IFrameElement.contentWindow.document);
                this.IFrameElement.style.height = windowHeight;
                // Listen to resize event on child window
                fromEvent(this.IFrameElement.contentWindow, 'resize')
                    .pipe(takeUntil(this.$unsubscribe))
                    .subscribe((e) => {
                    this.resize();
                });
                // Resize Listener
                interval(1000)
                    .pipe(takeUntil(this.$unsubscribe))
                    .subscribe((e) => {
                    this.resize();
                });
                // Catch CORS Error
            }
            catch (error) {
                this.logService
                    .log(`PershingIframeComponent - subscribeStylingEvents() - Event listeners and/or styles and resize
                                         listener could not be added due to a cross-origin frame error.`);
                this.logService.warn(error);
            }
        }
    }
    resize() {
        try {
            const windowHeight = this.getContentHeight(this.IFrameElement.contentWindow.document);
            this.IFrameElement.style.height = windowHeight;
        }
        catch (error) {
            this.logService.log('PershingIframeComponent - resize() - cross origin - iframe resize to default height');
            this.logService.warn(error);
            this.IFrameElement.style.height = this.DEFAULT_HEIGHT;
            this.$unsubscribe.next(void 0);
            this.$unsubscribe.complete();
        }
    }
    getContentHeight(document) {
        const body = document.body.scrollHeight;
        const htmlTag = document.documentElement.scrollHeight;
        return htmlTag > body ? htmlTag + 'px' : body + 'px';
    }
    subscribeCustomEvents() {
        try {
            // Listen to navigate event on child document, and propagate
            fromEvent(this.IFrameElement.contentWindow.document, 'portal.gotoview')
                .pipe(takeUntil(this.$unsubscribe))
                .subscribe((event) => {
                document.dispatchEvent(new CustomEvent(event.type, event));
            });
        }
        catch (error) {
            this.logService
                .log(`PershingIframeComponent - subscribeCustomEvents() - Event listeners and/or styles and resize listener
                                     could not be added due to a cross-origin frame error.`);
            this.logService.warn(error);
        }
    }
    subscribePostMessageEvents() {
        if (this.postMessageEventListener.observers.length > 0) {
            // Listen to windows postMessage Event
            fromEvent(window, 'message')
                .pipe(takeUntil(this.$unsubscribe))
                .subscribe(function (event) {
                // if (event.source && event.source.name === this.domID) {
                let obj = event.data;
                if (typeof event.data === 'string') {
                    try {
                        obj = JSON.parse(event.data);
                    }
                    catch (error) {
                        this.logService.info('PershingIframeComponent - subscribePostMessageEvents() - Error while converting string ' +
                            event.data +
                            ' to json.', error);
                    }
                }
                this.logService.log(`Received ${obj} from ${event.origin}`);
                this.postMessageEventListener.emit(obj);
                // }
            }.bind(this));
        }
    }
    generateIframeElement(anchor) {
        this.IFrameElement = this.renderer.createElement('iframe');
        this.IFrameElement.name = this.domID;
        this.IFrameElement.style.display = 'none';
        for (const key in this.options.style) {
            if (this.options.style[key]) {
                this.IFrameElement.style[key] = this.options.style[key];
            }
        }
        this.renderer.addClass(this.IFrameElement, 'per-iframe');
        this.renderer.insertBefore(anchor.parentNode, this.IFrameElement, anchor);
    }
    serialize(obj) {
        // Adds Params to url
        return ('?' +
            Object.keys(obj)
                .reduce((a, k) => {
                let paramValue = typeof obj[k] === 'object' ? JSON.stringify(obj[k]) : obj[k];
                // replace the whole value with blank when serialize method gets $ in the param object
                //     $ will be present in the params which needs to be populated with values from context object
                //     sample param from site-config -> "accountId": "${ACCOUNT|accountNumber}",
                if (paramValue && paramValue.indexOf('$') >= 0) {
                    paramValue = '';
                }
                a.push(k + '=' + encodeURIComponent(paramValue));
                return a;
            }, [])
                .join('&'));
    }
    packContextAndPublish(domainContext) {
        let params = this.contextParamSubstituter(domainContext);
        /*
                If options.params is not supplied and the parameters are added in the URL itself,
                then take out the params from the URL. contextParamSubstituter() returns null if there is no options.params.
                So check for null and check and extract any params that are part of the URL.
                In these cases, no context value replacement is possible, just hard coded strings are supported.
                If any contextual value needs to be passed, use options.params in the config.
            */
        if (!params) {
            let indexLocation = this._src.indexOf('?');
            if (indexLocation !== -1 && indexLocation < this._src.length) {
                let urlParams = this._src.substring(indexLocation + 1);
                if (urlParams && urlParams.length > 0) {
                    params = JSON.parse('{"' +
                        decodeURI(urlParams)
                            .replace(/"/g, '\\"')
                            .replace(/&/g, '","')
                            .replace(/=/g, '":"') +
                        '"}');
                }
                this._src = this._src.substring(0, this._src.indexOf('?')); // Set the updated URL by removing ? and params
            }
        }
        /*
            Commenting out the below piece for HTTP GET as the parameters are not getting passed
            for HTTP GET. Even for GET, the form input fields need to be created to
            properly pass the input values.
            */
        /*if(this.httpmethod === 'get'){
                this.appendParamsAndSubmitUrl(params);
            } else { */
        this.iframeForm.nativeElement.action = this._src;
        if (params) {
            let tempParamsMap = new Map(Object.entries(params));
            let index = 0;
            /* Update the model to set the values in the form */
            for (const key of tempParamsMap.keys()) {
                if (key) {
                    let tempValue = tempParamsMap.get(key);
                    this.postParams[index] = {
                        name: key,
                        value: this.serializeParamValue(tempValue),
                    };
                    index++;
                }
            }
        }
        this.initialContextPublishComplete = true;
        /* Delay to allow ChangeDetection to add the new values in form */
        setTimeout(() => {
            this.submitUrlAndUpdatePublishState();
        }, 1);
        /* } */
    }
    /*
          Serialize parameter value
          Stringify if object.
          If context value is not resolved, make it empty string.
          Encode the resultant vale and return.
          If null object, return empty string.
      */
    serializeParamValue(paramObj) {
        if (paramObj) {
            let paramValue = typeof paramObj === 'object' ? JSON.stringify(paramObj) : paramObj;
            if (paramValue && paramValue.indexOf('$') >= 0) {
                paramValue = '';
            }
            return paramValue;
        }
        else {
            return '';
        }
    }
    /*
          Function that processes the params config and poppulates the actual values of contets.
          Recursively calls itself if one of params has a value which itself is another object.
      */
    contextParamSubstituter(domainContext, paramObject) {
        /* If no options.params, return null */
        if (!this.options.params) {
            return null;
        }
        const routeContext = this.contextService.getRouteContext();
        const userContext = this.contextService.getUserContext();
        let params = JSON.parse(JSON.stringify(this.options.params));
        if (paramObject) {
            params = paramObject;
        }
        // context params are configured in site-config in below way under the params section,
        // "<param name for target app>" : "${<domain>|<field name from context model>}"
        //      sample - "accountId": "${ACCOUNT|accountNumber}",
        // Other context - ROUTECONTEXT, USERCONTEXT are currently supported
        //       "<param name for target app>" : "${ROUTECONTEXT|<any field that passed in ROUTECONTEXT>}"
        //       "<param name for target app>" : "${USERCONTEXT|<any field from User Context model>}"
        //              sample - "accountId": "${USERCONTEXT|brokerType}",
        //              blank spaces not allowed in above value
        // below code identifies context params with above structure and populate the values
        //      from the domain context object
        Object.keys(params).forEach((key) => {
            if (!!params[key] && typeof params[key] === 'object') {
                if (domainContext != null) {
                    this.contextParamSubstituter(domainContext, params[key]);
                }
                else {
                    this.contextParamSubstituter(null, params[key]);
                }
            }
            else if (params[key] && params[key].indexOf('$') >= 0) {
                const contextParam = params[key];
                const contextParamArray = contextParam
                    .slice(2, contextParam.length - 1)
                    .split('|');
                if (contextParamArray != null && contextParamArray.length > 0) {
                    if (domainContext != null &&
                        domainContext.domain != null &&
                        contextParamArray[0] === domainContext.domain.toUpperCase()) {
                        const contextValue = domainContext.value;
                        params[key] = contextValue[contextParamArray[1]];
                    }
                    else if (contextParamArray[0] === 'ROUTECONTEXT') {
                        // check for route context and param available in route context
                        // if not available, populate default value configured in site-config
                        // sample entry in site-config   -   "Screen": ${ROUTECONTEXT|screen|OVERVIEW}
                        //     if screen not available in route context OVERVIEW will be passed as default value
                        if (routeContext && routeContext[contextParamArray[1]]) {
                            params[key] = routeContext[contextParamArray[1]];
                        }
                        else if (contextParamArray[2]) {
                            params[key] = contextParamArray[2];
                        }
                    }
                    else if (userContext && contextParamArray[0] === 'USERCONTEXT') {
                        params[key] = userContext[contextParamArray[1]];
                    }
                    else if (contextParamArray[0] === 'APPSETTINGS') {
                        if (this.appSettings && this.appSettings[contextParamArray[1]]) {
                            params[key] = this.appSettings[contextParamArray[1]];
                        }
                    }
                    else if (contextParamArray[0] === 'SUBSESSIONID') {
                        if (contextParamArray[1]) {
                            params[key] = CommonUtil.getSubsessionidFromWindowAttribute(contextParamArray[1]);
                            // Remove above line and uncomment below to Implement the error handling for subsession ID with epoch values
                            /*
                                          const subSessionId = CommonUtil.getSubsessionidFromWindowAttribute(contextParamArray[1]);
                                          if (subSessionId) {
                                              params[key] = subSessionId;
                                          } else {
                                              this.noError = false;
                                          }
                                          */
                        }
                        else {
                            params[key] = CommonUtil.getSubsessionidFromWindowName();
                        }
                    }
                }
            }
        });
        return params;
    }
    appendParamsAndSubmitUrl(params) {
        // get domain from the input src+params
        const url = this._src != null && this._src.indexOf('?') !== -1
            ? this._src.split('?')[0]
            : this._src;
        const urlWithContextParams = url + this.serialize(params);
        this.iframeForm.nativeElement.action = urlWithContextParams; // set the context params in the url
        this.initialContextPublishComplete = true;
        this.iframeForm.nativeElement.submit();
    }
    submitUrlAndUpdatePublishState() {
        this.initialContextPublishComplete = true;
        this.iframeForm?.nativeElement.submit();
    }
    updateRegionSpecificSrcOptions() {
        let region = this.appSettings.region.toLowerCase();
        let space = this.appSettings.space?.toLowerCase();
        if (region === CoreConstants.ENV_DEV) {
            region = CoreConstants.ENV_QA;
        }
        else if (region === CoreConstants.ENV_TEST) {
            region = space; // currently supports space - uat, qa
        }
        else if (region === CoreConstants.ENV_QA) {
            region = space; // currently supports space - xat, demo
        }
        if (this.regionConfig && typeof this.regionConfig === 'string') {
            this.regionConfig = JSON.parse(this.regionConfig);
        }
        //For non-prod regions, if region specific configuration is not present then non-prod takes precedence
        if (region != CoreConstants.ENV_PROD && !this.regionConfig[region]) {
            region = CoreConstants.ENV_NON_PROD;
        }
        if (this.regionConfig[region]) {
            if (this.regionConfig[region].options) {
                this.options = this.regionConfig[region].options;
            }
            if (this.regionConfig[region].src) {
                this._src = this.regionConfig[region].src;
            }
        }
    }
    ngOnDestroy() {
        try {
            if (this.postMessageSubscription) {
                this.postMessageSubscription.unsubscribe();
            }
            this.$unsubscribe.next(void 0);
            this.$unsubscribe.complete();
        }
        catch (error) {
            this.logService.log('PershingIframeComponent - ngOnDestroy() - Error while unsubscribing all subscriptions during onDestroy', error);
        }
        this.resizeSub?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingIFrameComponent, deps: [{ token: i0.Renderer2 }, { token: i1.ContextService }, { token: i1.LogService }, { token: 'AppSettings', optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingIFrameComponent, selector: "pershing-iframe", inputs: { options: "options", regionConfig: "regionConfig", postMessageEventEmitter: "postMessageEventEmitter", src: "src" }, outputs: { postMessageEventListener: "postMessageEventListener" }, viewQueries: [{ propertyName: "iframeForm", first: true, predicate: ["iForm"], descendants: true }, { propertyName: "iframeAnchor", first: true, predicate: ["IFrameAnchor"], descendants: true }], ngImport: i0, template: `
    <ng-container
      *ngIf="noError; then iframeTemplate; else errorTemplate"
    ></ng-container>
    <ng-template #iframeTemplate>
      <div #IFrameAnchor>
        <ng-container
          *ngIf="isLoading"
          class="center-align"
          style="margin: auto;"
        >
          <mat-spinner [diameter]="40"></mat-spinner>
        </ng-container>
      </div>
      <form
        #iForm
        name="per-frame"
        [method]="httpmethod"
        [action]="_src | pershingSafe : 'resourceUrl'"
        [target]="domID"
      >
        <div *ngFor="let param of postParams">
          <input
            type="hidden"
            name="{{ param.name }}"
            value="{{ param.value }}"
          />
        </div>
      </form>
    </ng-template>
    <ng-template #errorTemplate>
      <div>
        <div class="alert-inpage error">
          <p><span>Error: SubSession Id is not present.</span></p>
        </div>
      </div>
    </ng-template>
  `, isInline: true, styles: [".per-iframe{overflow:hidden;width:100%;margin:auto;border:none}\n"], dependencies: [{ kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4$1.MatLegacyProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "pipe", type: i1.PershingSafePipe, name: "pershingSafe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingIFrameComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-iframe', template: `
    <ng-container
      *ngIf="noError; then iframeTemplate; else errorTemplate"
    ></ng-container>
    <ng-template #iframeTemplate>
      <div #IFrameAnchor>
        <ng-container
          *ngIf="isLoading"
          class="center-align"
          style="margin: auto;"
        >
          <mat-spinner [diameter]="40"></mat-spinner>
        </ng-container>
      </div>
      <form
        #iForm
        name="per-frame"
        [method]="httpmethod"
        [action]="_src | pershingSafe : 'resourceUrl'"
        [target]="domID"
      >
        <div *ngFor="let param of postParams">
          <input
            type="hidden"
            name="{{ param.name }}"
            value="{{ param.value }}"
          />
        </div>
      </form>
    </ng-template>
    <ng-template #errorTemplate>
      <div>
        <div class="alert-inpage error">
          <p><span>Error: SubSession Id is not present.</span></p>
        </div>
      </div>
    </ng-template>
  `, styles: [".per-iframe{overflow:hidden;width:100%;margin:auto;border:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1.ContextService }, { type: i1.LogService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['AppSettings']
                }] }]; }, propDecorators: { options: [{
                type: Input
            }], regionConfig: [{
                type: Input
            }], postMessageEventEmitter: [{
                type: Input
            }], postMessageEventListener: [{
                type: Output
            }], iframeForm: [{
                type: ViewChild,
                args: ['iForm']
            }], iframeAnchor: [{
                type: ViewChild,
                args: ['IFrameAnchor']
            }], src: [{
                type: Input
            }] } });

class PershingMessageDialog {
    constructor(messageDetails, elementRef, sanitizer, dialogRef) {
        this.messageDetails = messageDetails;
        this.elementRef = elementRef;
        this.sanitizer = sanitizer;
        this.dialogRef = dialogRef;
        this.callbackOnLinkClick = () => { };
        console.log('Message Dlg Comp');
        console.log(this.messageType);
        this.messageText = this.sanitizer.bypassSecurityTrustHtml(messageDetails.messageContent);
        this.messageType = messageDetails.messageType;
        // this.acceptButton = messageDetails.acceptButton;
        // this.cancelButton = messageDetails.cancelButton;
        this.positiveActionConfig = messageDetails.positiveActionConfig;
        this.negativeActionConfig = messageDetails.negativeActionConfig;
        this.buttonLabel = messageDetails.buttonLabel;
        let messageColor = MessagingConstants.MESSAGE_COLOR_CONFIRM;
        let messageIcon = MessagingConstants.CONFIRM_MESSAGE_ICON;
        if (this.messageType === MessagingConstants.MESSAGETYPE_ERROR) {
            messageColor = MessagingConstants.MESSAGE_COLOR_ERROR;
            messageIcon = MessagingConstants.ERROR_MESSAGE_ICON;
        }
        else if (this.messageType === MessagingConstants.MESSAGETYPE_WARN) {
            messageColor = MessagingConstants.MESSAGE_COLOR_WARNING;
            messageIcon = MessagingConstants.WARNING_MESSAGE_ICON;
        }
        else if (this.messageType === MessagingConstants.MESSAGETYPE_CONFIRM) {
            messageColor = MessagingConstants.MESSAGE_COLOR_CONFIRM;
            messageIcon = MessagingConstants.CONFIRM_MESSAGE_ICON;
        }
        else if (this.messageType === MessagingConstants.MESSAGETYPE_INFO) {
            messageColor = MessagingConstants.MESSAGE_COLOR_INFO;
            messageIcon = MessagingConstants.INFO_MESSAGE_ICON;
        }
        else if (this.messageType === MessagingConstants.MESSAGETYPE_TIP) {
            messageColor = MessagingConstants.MESSAGETYPE_COLOR_TIP;
            messageIcon = MessagingConstants.TIP_MESSAGE_ICON;
        }
        this.styleClasses = [messageColor, messageIcon];
        if (messageDetails.callbackOnLinkClick && messageDetails.linkButtonId) {
            this.callbackOnLinkClick = messageDetails.callbackOnLinkClick;
            this.linkButtonId = messageDetails.linkButtonId;
        }
    }
    onLinkClick() {
        this.dialogRef.close();
        this.callbackOnLinkClick();
    }
    ngAfterViewInit() {
        if (this.linkButtonId) {
            let linkElement = this.elementRef.nativeElement.querySelector(`#${this.linkButtonId}`);
            if (linkElement) {
                linkElement.addEventListener('click', this.onLinkClick.bind(this));
                linkElement.classList.add('text-link');
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingMessageDialog, deps: [{ token: MAT_LEGACY_DIALOG_DATA }, { token: i0.ElementRef }, { token: i1$1.DomSanitizer }, { token: i2$2.MatLegacyDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingMessageDialog, selector: "pershing-message-dialog", ngImport: i0, template: "<mat-dialog-content>\n        <div class=\"row\">\n            <div class=\"col-xs-2 col-sm-1 messaging-icon\"><i class=\"inline-icon fas fa-2x\" [ngClass]=\"styleClasses\"></i></div>\n            <div class=\"col-xs-10 col-sm\">\n                <span [innerHTML]=\"messageText\"></span>\n            </div>\n        </div>\n</mat-dialog-content>\n<div mat-dialog-actions>\n    <div class=\"action-buttons\">\n        <!--<button *ngFor=\"let actions of positiveActionConfig\" mat-raised-button [mat-dialog-close]=actions.emitVale color=\"primary\" class=\"small-button\">{{ actions.buttonName }}</button>\n        <button *ngIf=\"negativeActionConfig\" mat-stroked-button [mat-dialog-close]=negativeActionConfig.emitVale mat-button color=\"primary\" class=\"negative-action\"> {{ negativeActionConfig.buttonName}}</button>-->\n        <button *ngIf=\"!positiveActionConfig\" mat-raised-button mat-dialog-close=\"OK\" color=\"primary\" class=\"small-button\"> {{ buttonLabel }}</button>\n    </div>\n</div>\n", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i2$2.MatLegacyDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i2$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i2$2.MatLegacyDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingMessageDialog, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-message-dialog', template: "<mat-dialog-content>\n        <div class=\"row\">\n            <div class=\"col-xs-2 col-sm-1 messaging-icon\"><i class=\"inline-icon fas fa-2x\" [ngClass]=\"styleClasses\"></i></div>\n            <div class=\"col-xs-10 col-sm\">\n                <span [innerHTML]=\"messageText\"></span>\n            </div>\n        </div>\n</mat-dialog-content>\n<div mat-dialog-actions>\n    <div class=\"action-buttons\">\n        <!--<button *ngFor=\"let actions of positiveActionConfig\" mat-raised-button [mat-dialog-close]=actions.emitVale color=\"primary\" class=\"small-button\">{{ actions.buttonName }}</button>\n        <button *ngIf=\"negativeActionConfig\" mat-stroked-button [mat-dialog-close]=negativeActionConfig.emitVale mat-button color=\"primary\" class=\"negative-action\"> {{ negativeActionConfig.buttonName}}</button>-->\n        <button *ngIf=\"!positiveActionConfig\" mat-raised-button mat-dialog-close=\"OK\" color=\"primary\" class=\"small-button\"> {{ buttonLabel }}</button>\n    </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_LEGACY_DIALOG_DATA]
                }] }, { type: i0.ElementRef }, { type: i1$1.DomSanitizer }, { type: i2$2.MatLegacyDialogRef }]; } });

class PershingMessageComponent {
    constructor(matDialog, logService) {
        this.matDialog = matDialog;
        this.logService = logService;
        this.isDisplayDialogOnChange = true;
        this.notifyActionClicked = new EventEmitter();
        this.enableInpageMessage = false;
    }
    ngOnChanges(changes) {
        /*
            NXPNS-45916 - If a component has a need to display the dialog on when showMessage() is called, then
            they need to pass the input isDisplayDialogOnChange with 'false' when they create the message component instance.
           */
        if (this.isDisplayDialogOnChange === true) {
            this.initMessage();
        }
        this.logService.log('changes : ', changes);
    }
    initMessage() {
        if (this.message == null || this.messageType == null) {
            this.logService.error('No input messageContent/messageType available');
        }
        else {
            if (this.displayType.toLowerCase() === MessagingConstants.DISPLAYTYPE_INPAGE) {
                this.showInpageMessage();
            }
            else if (this.displayType.toLowerCase() === MessagingConstants.DISPLAYTYPE_MODAL) {
                setTimeout(() => {
                    this.showModalMessage();
                }, 0);
            }
        }
    }
    showInpageMessage() {
        this.enableInpageMessage = true;
        if (this.hideAfterInterval && this.hideAfterInterval !== null) {
            this.hideMessageAfterInterval(this.hideAfterInterval);
        }
    }
    showModalMessage() {
        this.enableInpageMessage = false;
        if (this.width && this.width != null) {
            this.modalWidth = this.width;
        }
        else {
            this.modalWidth = MessagingConstants.MODAL_WIDTH;
        }
        if (!this.buttonLabel || this.buttonLabel == null) {
            this.buttonLabel = MessagingConstants.ACTION_BUTTON_LABEL;
        }
        this.modalDialogRef = this.matDialog.open(PershingMessageDialog, {
            disableClose: true,
            autoFocus: false,
            id: 'modal-message-' + this.messageType,
            width: this.modalWidth,
            data: {
                messageContent: this.message,
                messageType: this.messageType,
                buttonLabel: this.buttonLabel,
                callbackOnLinkClick: this.callbackOnLinkClick,
                linkButtonId: this.linkButtonId,
            },
        });
        this.modalDialogRef.afterClosed().subscribe((result) => {
            this.notifyActionClicked.emit(result);
            this.logService.log('result ', result);
        });
    }
    showMessage() {
        if (this.displayType) {
            if (this.displayType.toLowerCase() === MessagingConstants.DISPLAYTYPE_INPAGE) {
                this.showInpageMessage();
            }
            else if (this.displayType.toLowerCase() === MessagingConstants.DISPLAYTYPE_MODAL) {
                this.showModalMessage();
            }
        }
        else {
            this.logService.error('NxpMessageComponent - showMessage() : displayType not available');
        }
        // return this.getDialogReference();
    }
    hideMessageAfterInterval(timer) {
        setTimeout(() => {
            this.enableInpageMessage = false;
        }, Number(timer));
    }
    getDialogReference() {
        return this.modalDialogRef;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingMessageComponent, deps: [{ token: i2$2.MatLegacyDialog }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingMessageComponent, selector: "pershing-message", inputs: { displayType: "displayType", messageType: "messageType", message: "message", callbackOnLinkClick: "callbackOnLinkClick", linkButtonId: "linkButtonId", buttonLabel: "buttonLabel", hideAfterInterval: "hideAfterInterval", width: "width", isDisplayDialogOnChange: "isDisplayDialogOnChange" }, outputs: { notifyActionClicked: "notifyActionClicked" }, usesOnChanges: true, ngImport: i0, template: "<div *ngIf=\"enableInpageMessage\">\n    <div *ngIf=\"message\" class=\"alert-inpage\" [ngClass]=\"messageType\">\n    <p><span [innerHTML]=\"message\"></span></p>\n    </div>\n</div>", dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-message', template: "<div *ngIf=\"enableInpageMessage\">\n    <div *ngIf=\"message\" class=\"alert-inpage\" [ngClass]=\"messageType\">\n    <p><span [innerHTML]=\"message\"></span></p>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i2$2.MatLegacyDialog }, { type: i1.LogService }]; }, propDecorators: { displayType: [{
                type: Input
            }], messageType: [{
                type: Input
            }], message: [{
                type: Input
            }], callbackOnLinkClick: [{
                type: Input
            }], linkButtonId: [{
                type: Input
            }], buttonLabel: [{
                type: Input
            }], hideAfterInterval: [{
                type: Input
            }], width: [{
                type: Input
            }], isDisplayDialogOnChange: [{
                type: Input
            }], notifyActionClicked: [{
                type: Output
            }] } });

/**
 * @desc NxpModalComponent is used primarily to open a dialog with a dynamic component
 */
class PershingModalComponent {
    constructor(pershingModalService, dialog, logService) {
        this.pershingModalService = pershingModalService;
        this.dialog = dialog;
        this.logService = logService;
        let dialogRef;
        this.modalServiceSubscription =
            this.pershingModalService.modalProperties$.subscribe((property) => {
                // console.log('Subscription called for : ' + property.component);
                try {
                    let defaultModalConfig = {
                        disableClose: property.modalConfig.disableClose,
                        panelClass: property.modalConfig.panelClass,
                        height: property.modalConfig.height,
                        maxHeight: property.modalConfig.maxHeight,
                        width: property.modalConfig.width,
                        maxWidth: property.modalConfig.maxWidth,
                        autoFocus: property.modalConfig.autoFocus,
                        id: property.modalConfig.modalId,
                    };
                    if (property.modalConfig.data) {
                        defaultModalConfig.data = property.modalConfig.data;
                    }
                    dialogRef = this.dialog.open(property.component, defaultModalConfig);
                    this.pershingModalService.dialogRef = dialogRef;
                }
                catch (e) {
                    logService.error(e);
                    return property; // handling any exception
                }
            });
    }
    ngOnInit() {
        //constructor is left blank intentionally
    }
    ngOnDestroy() {
        this.modalServiceSubscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingModalComponent, deps: [{ token: PershingModalService }, { token: i2$2.MatLegacyDialog }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingModalComponent, selector: "pershing-modal", ngImport: i0, template: `<ng-container></ng-container>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'pershing-modal',
                    template: `<ng-container></ng-container>`,
                }]
        }], ctorParameters: function () { return [{ type: PershingModalService }, { type: i2$2.MatLegacyDialog }, { type: i1.LogService }]; } });

// TODO: During ng-build, we get this warning:
// 'TemplateRef' is imported from external module '@angular/core' but never used
// Looks like this is a bug with Angular compiler: https://github.com/dherges/ng-packagr/issues/710#issuecomment-375890469
class PershingResponsiveComponent {
    constructor() {
        this.respondToWindow = false;
        //constructor is left blank intentionally
    }
    // Might need to update the range per Material responsive UI breakpoint
    // https://material.io/guidelines/layout/responsive-ui.html#responsive-ui-patterns
    ngOnInit() {
        if (this.respondToWindow) {
            this.pershingResponsiveWindow = null;
        }
        else {
            this.pershingResponsiveWindow = new Date().getMilliseconds().toString() + Math.random();
        }
        this.sizeConfig = {
            small: { sizes: { window: this.pershingResponsiveWindow, min: 0, max: 595 } },
            medium: { sizes: { window: this.pershingResponsiveWindow, min: 596, max: 811 } },
            large: { sizes: { window: this.pershingResponsiveWindow, min: 812, max: 9999 } }
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingResponsiveComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingResponsiveComponent, selector: "pershing-responsive", inputs: { respondToWindow: "respondToWindow", small: "small", medium: "medium", large: "large" }, ngImport: i0, template: "<div *ngIf=\"!respondToWindow; else respondToWindowElement\" class=\"pershing-responsive\" [responsive-window]=\"pershingResponsiveWindow\">\n    <ng-template [responsive]=\"sizeConfig.small\">\n        <ng-template [ngTemplateOutlet]=\"small\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.medium\">\n        <ng-template [ngTemplateOutlet]=\"medium\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.large\">\n        <ng-template [ngTemplateOutlet]=\"large\"></ng-template>\n    </ng-template>\n</div>\n\n<ng-template #respondToWindowElement>\n    <ng-template [responsive]=\"sizeConfig.small\">\n        <ng-template [ngTemplateOutlet]=\"small\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.medium\">\n        <ng-template [ngTemplateOutlet]=\"medium\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.large\">\n        <ng-template [ngTemplateOutlet]=\"large\"></ng-template>\n    </ng-template>\n</ng-template>\n", styles: [".pershing-responsive:{box-sizing:border-box;width:100%}\n"], dependencies: [{ kind: "directive", type: i1$2.ResponsiveDirective, selector: "[responsive]", inputs: ["responsive", "responsiveContainer"], outputs: ["changes"] }, { kind: "directive", type: i1$2.ResponsiveWindowDirective, selector: "[responsive-window]", inputs: ["responsive-window"], exportAs: ["container"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingResponsiveComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-responsive', template: "<div *ngIf=\"!respondToWindow; else respondToWindowElement\" class=\"pershing-responsive\" [responsive-window]=\"pershingResponsiveWindow\">\n    <ng-template [responsive]=\"sizeConfig.small\">\n        <ng-template [ngTemplateOutlet]=\"small\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.medium\">\n        <ng-template [ngTemplateOutlet]=\"medium\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.large\">\n        <ng-template [ngTemplateOutlet]=\"large\"></ng-template>\n    </ng-template>\n</div>\n\n<ng-template #respondToWindowElement>\n    <ng-template [responsive]=\"sizeConfig.small\">\n        <ng-template [ngTemplateOutlet]=\"small\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.medium\">\n        <ng-template [ngTemplateOutlet]=\"medium\"></ng-template>\n    </ng-template>\n\n    <ng-template [responsive]=\"sizeConfig.large\">\n        <ng-template [ngTemplateOutlet]=\"large\"></ng-template>\n    </ng-template>\n</ng-template>\n", styles: [".pershing-responsive:{box-sizing:border-box;width:100%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { respondToWindow: [{
                type: Input
            }], small: [{
                type: Input
            }], medium: [{
                type: Input
            }], large: [{
                type: Input
            }] } });

class PershingCommonLabels {
    static { this.REQUIRED_ERROR_CASE_MESSAGE = 'NXP-PERSHING-COMMON.PERSHING-INPUT.REQUIRED_ERROR_MESSAGE'; }
    static { this.DEFAULT_ERROR_CASE_MESSAGE = 'NXP-PERSHING-COMMON.PERSHING-INPUT.DEFAULT_ERROR_MESSAGE'; }
}

class PershingInputComponent {
    constructor(translationService, cd) {
        this.translationService = translationService;
        this.cd = cd;
        this.autocomplete = 'off';
        this.type = 'text';
        this.value = '';
        this.showTooltip = false;
        this.enableFilterDropdown = false;
        this.filterOptions = [];
        this.blur = new EventEmitter();
        this.formControlErrorState = false;
        this.formControlWarningState = false;
        this.reactOnlyAfterBlur = false;
        this.matFormFieldClass = 'input-success';
        this.onChange = (value) => {
            //method is left blank intentionally
        };
        this.onTouched = () => {
            //method is left blank intentionally
        };
        this.translationService.addTranslationFolder('@pershing/pershing-common', 'node_modules/@pershing/pershing-common/lib');
    }
    ngOnInit() {
        this.filteredOptions = this.formControl.valueChanges
            .pipe(startWith(''), map(value => this._filter(value)));
        this.formControl.statusChanges.subscribe((status) => {
            if (this.formControl.touched) {
                if (status === 'INVALID') {
                    this.checkFormStatus();
                }
                else {
                    this.resetState();
                }
            }
        });
    }
    _filter(value) {
        const filterValue = value.toLowerCase();
        return this.filterOptions.filter(option => option.toLowerCase().includes(filterValue));
    }
    invokeValidation() {
        this.reactOnlyAfterBlur = true;
        this.checkFormStatus();
        this.blur.emit();
    }
    checkFormStatus() {
        this.resetState();
        if (this.reactOnlyAfterBlur) {
            let errors = this.formControl.errors;
            let formControlMetadata = this.formControlMetadata;
            let consolidatedError = '';
            let consolidatedWarning = '';
            let tooltipContent = '';
            let tooltipState = '';
            if (errors) {
                Object.keys(errors).forEach((errorKey) => {
                    if (formControlMetadata[errorKey]) {
                        if (formControlMetadata[errorKey].errorType === 'error') {
                            let translation = this.translationService.get(formControlMetadata[errorKey].message);
                            translation.subscribe((value) => {
                                if (consolidatedError === '') {
                                    consolidatedError = '&nbsp;' + consolidatedError + value;
                                }
                                else {
                                    consolidatedError = consolidatedError + '<br>' + value;
                                }
                            });
                        }
                        if (formControlMetadata[errorKey].errorType === 'warning') {
                            let translation = this.translationService.get(formControlMetadata[errorKey].message);
                            translation.subscribe((value) => {
                                if (consolidatedWarning === '') {
                                    consolidatedWarning = '&nbsp;' + consolidatedWarning + value;
                                }
                                else {
                                    consolidatedWarning = consolidatedWarning + '<br>' + value;
                                }
                            });
                        }
                    }
                    else {
                        // Metadata not available
                        if (errorKey === 'required') {
                            this.translationService.get(PershingCommonLabels.REQUIRED_ERROR_CASE_MESSAGE).subscribe(translatedLiteral => {
                                consolidatedError = translatedLiteral;
                            });
                        }
                        else {
                            // could not determine the input state as metadata not available
                            this.translationService.get(PershingCommonLabels.DEFAULT_ERROR_CASE_MESSAGE).subscribe(translatedLiteral => {
                                consolidatedError = translatedLiteral;
                            });
                        }
                    }
                });
            }
            // Give priority to error messages and ignore other messages (say : warning messages will be ignored)
            // If multiple messages of same type (say multiple error messages), they will be grouped and shown one below the another
            if (consolidatedError && consolidatedError !== '') {
                this.formControlErrorMessage = consolidatedError;
                this.formControlErrorState = true;
                this.detectChange();
                tooltipContent = this.formatTooltipContent(consolidatedError);
                tooltipState = 'error-state';
            }
            else if (consolidatedWarning && consolidatedWarning !== '') {
                this.formControlWarningMessage = consolidatedWarning;
                this.formControlWarningState = true;
                this.detectChange();
                tooltipContent = this.formatTooltipContent(consolidatedWarning);
                tooltipState = 'warning-state';
            }
            // set tooltip content and class only when tooltip is enabled
            if (this.showTooltip) {
                this.tooltipContent = tooltipContent;
                this.tooltipClass = tooltipState;
            }
            this.updateFormFieldStyling();
        }
    }
    resetState() {
        this.formControlErrorMessage = '';
        this.formControlWarningMessage = '';
        this.formControlErrorState = false;
        this.formControlWarningState = false;
        this.tooltipContent = '';
        this.tooltipClass = '';
        this.updateFormFieldStyling();
    }
    detectChange() {
        if (isDevMode()) {
            this.cd.detectChanges();
        }
    }
    formatTooltipContent(message) {
        // remove any html content in the tooltip message
        let regex = /&nbsp;|<br>/gi;
        message = message.replace(regex, ' ');
        return message;
    }
    updateFormFieldStyling() {
        if (this.formControlWarningState && !this.formControlErrorState) {
            // this.matFormFieldClass = ['tooltip', 'input-warning'];
            this.matFormFieldClass = 'input-warning'; // use 'tooltip-input-warning' once tooltip class added in branding
        }
        else {
            // this.matFormFieldClass = ['tooltip', 'input-success'];
            this.matFormFieldClass = 'input-success'; // use 'tooltip-input-success' once tooltip class added in branding
        }
    }
    writeValue(value) {
        // this.control.setValue(value);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingInputComponent, deps: [{ token: i1.PershingTranslationService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingInputComponent, selector: "pershing-input", inputs: { autocomplete: "autocomplete", autofocus: "autofocus", checked: "checked", max: "max", class: "class", maxlength: "maxlength", min: "min", name: "name", placeholder: "placeholder", required: "required", type: "type", value: "value", formControl: "formControl", formControlMetadata: "formControlMetadata", showTooltip: "showTooltip", enableFilterDropdown: "enableFilterDropdown", filterOptions: "filterOptions" }, outputs: { blur: "blur" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => PershingInputComponent),
                multi: true
            }
        ], ngImport: i0, template: "<mat-form-field appearance=\"outline\" [ngClass]=\"matFormFieldClass\" class=\"show-tooltip\" [class]=\"class\">\n\n    <input *ngIf=\"showTooltip && !enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n\n    #tooltip=\"matTooltip\"\n    matTooltipPosition=\"right\"\n    [matTooltip]=\"tooltipContent\"\n    [matTooltipClass]=\"tooltipClass\"\n\n    (blur)=\"invokeValidation();\">\n\n    <input *ngIf=\"!showTooltip  && !enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n\n    (blur)=\"invokeValidation();\">\n\n    <input *ngIf=\"showTooltip && enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n\n    #tooltip=\"matTooltip\"\n    matTooltipPosition=\"right\"\n    [matTooltip]=\"tooltipContent\"\n    [matTooltipClass]=\"tooltipClass\"\n\n    [matAutocomplete]=\"auto\"\n\n    (blur)=\"invokeValidation();\">\n\n    <input *ngIf=\"!showTooltip && enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n     \n    [matAutocomplete]=\"auto\"\n\n    (blur)=\"invokeValidation();\">\n\n      <mat-error *ngIf=\"formControlErrorState\" ngClass=\"negative\">\n          <i class=\"fa fa-exclamation-circle\"></i> <span [innerHTML]=\"formControlErrorMessage\"></span>\n      </mat-error>\n      <mat-error *ngIf=\"formControlWarningState\" ngClass=\"warning\">\n          <i class=\"fa fa-exclamation-triangle\"></i> <span [innerHTML]=\"formControlWarningMessage\"></span>\n      </mat-error>\n\n\n      <mat-autocomplete #auto=\"matAutocomplete\">\n        <mat-option *ngFor=\"let option of filteredOptions  | async\" [value]=\"option\">\n          {{option}}\n        </mat-option>\n      </mat-autocomplete>\n\n</mat-form-field>\n", dependencies: [{ kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4$2.MatLegacyError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i4$2.MatLegacyFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i5$1.MatLegacyInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", exportAs: ["matInput"] }, { kind: "component", type: i6$1.MatLegacyAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i6$1.MatLegacyAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "component", type: i7$1.MatLegacyOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i8.MatLegacyTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i2.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-input', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => PershingInputComponent),
                            multi: true
                        }
                    ], template: "<mat-form-field appearance=\"outline\" [ngClass]=\"matFormFieldClass\" class=\"show-tooltip\" [class]=\"class\">\n\n    <input *ngIf=\"showTooltip && !enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n\n    #tooltip=\"matTooltip\"\n    matTooltipPosition=\"right\"\n    [matTooltip]=\"tooltipContent\"\n    [matTooltipClass]=\"tooltipClass\"\n\n    (blur)=\"invokeValidation();\">\n\n    <input *ngIf=\"!showTooltip  && !enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n\n    (blur)=\"invokeValidation();\">\n\n    <input *ngIf=\"showTooltip && enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n\n    #tooltip=\"matTooltip\"\n    matTooltipPosition=\"right\"\n    [matTooltip]=\"tooltipContent\"\n    [matTooltipClass]=\"tooltipClass\"\n\n    [matAutocomplete]=\"auto\"\n\n    (blur)=\"invokeValidation();\">\n\n    <input *ngIf=\"!showTooltip && enableFilterDropdown\" matInput\n\n    [autocomplete]=\"autocomplete\"\n    [autofocus]=\"autofocus\"\n    [checked]=\"checked\"\n    [max]=\"max\"\n    [maxlength]=\"maxlength\"\n    [min]=\"min\"\n    [name]=\"name\"\n    [placeholder]=\"placeholder\"\n    [required]=\"required\"\n    [type]=\"type\"\n    [value]=\"value\"\n\n    [formControl]=formControl\n     \n    [matAutocomplete]=\"auto\"\n\n    (blur)=\"invokeValidation();\">\n\n      <mat-error *ngIf=\"formControlErrorState\" ngClass=\"negative\">\n          <i class=\"fa fa-exclamation-circle\"></i> <span [innerHTML]=\"formControlErrorMessage\"></span>\n      </mat-error>\n      <mat-error *ngIf=\"formControlWarningState\" ngClass=\"warning\">\n          <i class=\"fa fa-exclamation-triangle\"></i> <span [innerHTML]=\"formControlWarningMessage\"></span>\n      </mat-error>\n\n\n      <mat-autocomplete #auto=\"matAutocomplete\">\n        <mat-option *ngFor=\"let option of filteredOptions  | async\" [value]=\"option\">\n          {{option}}\n        </mat-option>\n      </mat-autocomplete>\n\n</mat-form-field>\n" }]
        }], ctorParameters: function () { return [{ type: i1.PershingTranslationService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { autocomplete: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], checked: [{
                type: Input
            }], max: [{
                type: Input
            }], class: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], min: [{
                type: Input
            }], name: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], required: [{
                type: Input
            }], type: [{
                type: Input
            }], value: [{
                type: Input
            }], formControl: [{
                type: Input
            }], formControlMetadata: [{
                type: Input
            }], showTooltip: [{
                type: Input
            }], enableFilterDropdown: [{
                type: Input
            }], filterOptions: [{
                type: Input
            }], blur: [{
                type: Output
            }] } });

class PershingEscapeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(content) {
        const htmlContent = this.sanitizer.bypassSecurityTrustHtml(content);
        return htmlContent;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingEscapeHtmlPipe, deps: [{ token: i1$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PershingEscapeHtmlPipe, name: "keepHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingEscapeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'keepHtml' }]
        }], ctorParameters: function () { return [{ type: i1$1.DomSanitizer }]; } });

class PershingComponent {
    constructor(auth) {
        this.auth = auth;
        this.isExpanded = true;
        this.actions = null;
        this.contentStyle = null;
        this.componentContent = undefined;
    }
    convertCamelToKebab(key) {
        return key
            .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
            .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
            .toLowerCase();
    }
    createElementInputs(inputs) {
        let inputString = '';
        for (const key in inputs) {
            if (inputs[key]) {
                console.log('typeof ', key, typeof inputs[key] === 'object');
                const value = (typeof inputs[key] === 'object') ? JSON.stringify(inputs[key]) : inputs[key];
                inputString += ' ' + this.convertCamelToKebab(key) + '=\'' + value + '\'';
            }
        }
        return inputString;
    }
    ngOnInit() {
        if (this.componentMeta && typeof this.componentMeta === 'string') {
            this.componentMeta = JSON.parse(this.componentMeta);
        }
        if (this.componentMeta && this.componentMeta.isAngularElements) {
            this.componentContent = '<' + this.componentMeta.selector +
                this.createElementInputs(this.componentMeta.input) + '></' + this.componentMeta.selector + '>';
        }
        this.setContentStyle(this.componentMeta);
        this.entitlementCheck(this.componentMeta.entitlement);
        this.actions = (this.componentMeta.actions) ? Object.keys(this.componentMeta.actions) : null;
    }
    setContentStyle(componentData) {
        if (componentData.height !== 'FULL') {
            this.contentStyle = {
                'height': componentData.height,
                'overflow-y': 'auto'
            };
        }
    }
    entitlementCheck(entitlement) {
        if (entitlement) {
            this.isEntitled = this.auth.isEntitled(entitlement);
        }
    }
    ngOnDestroy() {
        console.log('PERSHING-COMPONENT ON DESTROY');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingComponent, deps: [{ token: i1.PermissionCheckerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingComponent, selector: "pershing-component", inputs: { componentMeta: "componentMeta" }, queries: [{ propertyName: "templateRef", first: true, predicate: TemplateRef, descendants: true }], ngImport: i0, template: "<div *ngIf=\"!componentMeta.dashboardView\">\n    <div *ngIf=\"isEntitled === undefined || isEntitled\">\n        <ng-container *ngIf=\"componentContent !== undefined; else templateRendering\">\n            <div [innerHTML]=\"componentContent | keepHtml\"></div>\n        </ng-container>\n        <ng-template #templateRendering>\n            <ng-template [ngTemplateOutlet]=\"templateRef\"></ng-template>\n        </ng-template>\n    </div>\n</div>\n<div *ngIf=\"componentMeta.dashboardView && (componentMeta.collapsible === undefined || componentMeta.collapsible === true) && (isEntitled === undefined || isEntitled)\" class=\"dc\">\n    <mat-expansion-panel [expanded]=\"isExpanded\" [ngClass]=\"componentMeta.componentClass\" [ngStyle]=\"componentMeta.componentStyle\">\n\n        <!-- Header -->\n        <mat-expansion-panel-header (click)=\"isExpanded = !isExpanded\">\n            <mat-panel-title>\n                {{ componentMeta.displayName }}\n            </mat-panel-title>\n            <div class=\"dc-Actions\" *ngIf=\"actions\" [ngClass]=\"{'expanded': isExpanded}\">\n                <span *ngFor=\"let key of actions\" class=\"right text-link margin-right-10\">\n                    {{ key }}\n                </span>\n            </div>\n        </mat-expansion-panel-header>\n\n        <!-- Content -->\n        <div [ngStyle]=\"contentStyle\">\n            <ng-content></ng-content>\n            <ng-container *ngIf=\"componentContent !== undefined; else templateRendering\">\n                <div [innerHTML]=\"componentContent | keepHtml\"></div>\n            </ng-container>\n            <ng-template #templateRendering>\n                <ng-template [ngTemplateOutlet]=\"templateRef\"></ng-template>\n            </ng-template>\n        </div>\n    </mat-expansion-panel>\n</div>\n\n<div *ngIf=\"componentMeta.dashboardView && componentMeta.collapsible === false && (isEntitled === undefined || isEntitled)\" class=\"dc noCollapse\">\n    <mat-expansion-panel expanded=true [ngClass]=\"componentMeta.componentClass\" [ngStyle]=\"componentMeta.componentStyle\">\n\n        <!-- Header -->\n        <div class=\"title padding-top-10\" *ngIf=\"componentMeta.displayName\">\n            <mat-panel-title>\n                {{ componentMeta.displayName }}\n            </mat-panel-title>\n            <div class=\"dc-Actions expanded\" *ngIf=\"actions\">\n                <span *ngFor=\"let key of actions\" class=\"right text-link margin-right-10\">\n                    {{ key }}\n                </span>\n            </div>\n        </div>\n\n        <!-- Content -->\n        <div [ngStyle]=\"contentStyle\" class=\"portletBody\">\n            <ng-content></ng-content>\n            <ng-container *ngIf=\"componentContent !== undefined; else templateRendering\">\n                <div [innerHTML]=\"componentContent | keepHtml\"></div>\n            </ng-container>\n            <ng-template #templateRendering>\n                <ng-template [ngTemplateOutlet]=\"templateRef\"></ng-template>\n            </ng-template>\n        </div>\n    </mat-expansion-panel>\n\n\n</div>", styles: [".full-height{display:flex;height:100%}.dc .mat-expansion-panel-header{background:inherit!important;padding:0 24px!important}.dc .mat-expansion-panel{border:none}.dc-Actions{padding-top:3px;padding-bottom:0;transition:all .25s ease}.dc-Actions.expanded{padding-top:0;padding-bottom:10px;transition:all .25s ease}.portletBody{overflow-y:auto;overflow-x:clip;scrollbar-width:5px}.title{height:36px}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i2$1.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i2$1.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i2$1.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "pipe", type: PershingEscapeHtmlPipe, name: "keepHtml" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-component', template: "<div *ngIf=\"!componentMeta.dashboardView\">\n    <div *ngIf=\"isEntitled === undefined || isEntitled\">\n        <ng-container *ngIf=\"componentContent !== undefined; else templateRendering\">\n            <div [innerHTML]=\"componentContent | keepHtml\"></div>\n        </ng-container>\n        <ng-template #templateRendering>\n            <ng-template [ngTemplateOutlet]=\"templateRef\"></ng-template>\n        </ng-template>\n    </div>\n</div>\n<div *ngIf=\"componentMeta.dashboardView && (componentMeta.collapsible === undefined || componentMeta.collapsible === true) && (isEntitled === undefined || isEntitled)\" class=\"dc\">\n    <mat-expansion-panel [expanded]=\"isExpanded\" [ngClass]=\"componentMeta.componentClass\" [ngStyle]=\"componentMeta.componentStyle\">\n\n        <!-- Header -->\n        <mat-expansion-panel-header (click)=\"isExpanded = !isExpanded\">\n            <mat-panel-title>\n                {{ componentMeta.displayName }}\n            </mat-panel-title>\n            <div class=\"dc-Actions\" *ngIf=\"actions\" [ngClass]=\"{'expanded': isExpanded}\">\n                <span *ngFor=\"let key of actions\" class=\"right text-link margin-right-10\">\n                    {{ key }}\n                </span>\n            </div>\n        </mat-expansion-panel-header>\n\n        <!-- Content -->\n        <div [ngStyle]=\"contentStyle\">\n            <ng-content></ng-content>\n            <ng-container *ngIf=\"componentContent !== undefined; else templateRendering\">\n                <div [innerHTML]=\"componentContent | keepHtml\"></div>\n            </ng-container>\n            <ng-template #templateRendering>\n                <ng-template [ngTemplateOutlet]=\"templateRef\"></ng-template>\n            </ng-template>\n        </div>\n    </mat-expansion-panel>\n</div>\n\n<div *ngIf=\"componentMeta.dashboardView && componentMeta.collapsible === false && (isEntitled === undefined || isEntitled)\" class=\"dc noCollapse\">\n    <mat-expansion-panel expanded=true [ngClass]=\"componentMeta.componentClass\" [ngStyle]=\"componentMeta.componentStyle\">\n\n        <!-- Header -->\n        <div class=\"title padding-top-10\" *ngIf=\"componentMeta.displayName\">\n            <mat-panel-title>\n                {{ componentMeta.displayName }}\n            </mat-panel-title>\n            <div class=\"dc-Actions expanded\" *ngIf=\"actions\">\n                <span *ngFor=\"let key of actions\" class=\"right text-link margin-right-10\">\n                    {{ key }}\n                </span>\n            </div>\n        </div>\n\n        <!-- Content -->\n        <div [ngStyle]=\"contentStyle\" class=\"portletBody\">\n            <ng-content></ng-content>\n            <ng-container *ngIf=\"componentContent !== undefined; else templateRendering\">\n                <div [innerHTML]=\"componentContent | keepHtml\"></div>\n            </ng-container>\n            <ng-template #templateRendering>\n                <ng-template [ngTemplateOutlet]=\"templateRef\"></ng-template>\n            </ng-template>\n        </div>\n    </mat-expansion-panel>\n\n\n</div>", styles: [".full-height{display:flex;height:100%}.dc .mat-expansion-panel-header{background:inherit!important;padding:0 24px!important}.dc .mat-expansion-panel{border:none}.dc-Actions{padding-top:3px;padding-bottom:0;transition:all .25s ease}.dc-Actions.expanded{padding-top:0;padding-bottom:10px;transition:all .25s ease}.portletBody{overflow-y:auto;overflow-x:clip;scrollbar-width:5px}.title{height:36px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.PermissionCheckerService }]; }, propDecorators: { componentMeta: [{
                type: Input
            }], templateRef: [{
                type: ContentChild,
                args: [TemplateRef]
            }] } });

class ContentManagementService {
    constructor(serviceRouter, http) {
        this.serviceRouter = serviceRouter;
        this.http = http;
        this.headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }
    retrieveContent(serviceDefinition, requestBody, ignoreOptions) {
        let baseUrl = '';
        if (ignoreOptions == undefined || ignoreOptions == null) {
            baseUrl = this.serviceRouter.getServiceRouteURL(serviceDefinition);
        }
        else {
            baseUrl = this.serviceRouter.getServiceRouteURL(serviceDefinition, ignoreOptions);
        }
        return this.http.post(`${baseUrl}`, requestBody, { headers: this.headers });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementService, deps: [{ token: i1.ServiceRouter }, { token: i2$3.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContentManagementService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.ServiceRouter }, { type: i2$3.HttpClient }]; } });

class PershingContentManagementComponent {
    constructor(contentManagementService) {
        this.contentManagementService = contentManagementService;
        this.errorEmitter = new EventEmitter();
    }
    ngOnInit() {
        this.contentSubscription = this.contentManagementService
            .retrieveContent(this.serviceDefinition, this.requestParams, this.ignoreOptions)
            .subscribe((data) => {
            if (data && data.response) {
                this.content = data.response.content;
            }
            else {
                this.errorEmitter.emit('No data');
            }
        }, (error) => {
            this.errorEmitter.emit(`Error in retrieving content. Error message: ${error}`);
        });
    }
    ngOnDestroy() {
        this.contentSubscription.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingContentManagementComponent, deps: [{ token: ContentManagementService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingContentManagementComponent, selector: "pershing-content-management", inputs: { requestParams: "requestParams", serviceDefinition: "serviceDefinition", ignoreOptions: "ignoreOptions" }, outputs: { errorEmitter: "errorEmitter" }, ngImport: i0, template: "<div *ngIf=\"content\" [innerHTML]=\"content | pershingSafe: 'html' \"></div>\n", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.PershingSafePipe, name: "pershingSafe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingContentManagementComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-content-management', template: "<div *ngIf=\"content\" [innerHTML]=\"content | pershingSafe: 'html' \"></div>\n" }]
        }], ctorParameters: function () { return [{ type: ContentManagementService }]; }, propDecorators: { requestParams: [{
                type: Input
            }], serviceDefinition: [{
                type: Input
            }], errorEmitter: [{
                type: Output
            }], ignoreOptions: [{
                type: Input
            }] } });

class PershingTooltipComponent {
    constructor() {
        this.className = 'text-link';
        // Default delay in showing up the tooltip is 300 milliseconds.
        // It can be overridden by passing the attribute [tooltipDelay]="'2000'"
        this.tooltipDelay = 300;
    }
    openToolTip() {
        this.timeOut = setTimeout(() => {
            this.trigger.openMenu();
        }, this.tooltipDelay);
    }
    closeToolTip() {
        clearTimeout(this.timeOut);
        this.trigger.closeMenu();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingTooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingTooltipComponent, selector: "pershing-tooltip", inputs: { displayValue: "displayValue", triggerEvent: "triggerEvent", className: "className", tooltipDelay: "tooltipDelay" }, viewQueries: [{ propertyName: "menu", first: true, predicate: MatLegacyMenu, descendants: true }, { propertyName: "trigger", first: true, predicate: MatLegacyMenuTrigger, descendants: true }], ngImport: i0, template: "<span *ngIf=\"triggerEvent==='hover'\" [matMenuTriggerFor]=\"menu\" #menuTrigger=\"matMenuTrigger\" (mouseenter)=\"openToolTip()\" (mouseout)=\"closeToolTip()\" class='tooltip-link'>{{displayValue}}</span>\n<span *ngIf=\"triggerEvent==='click'\" [matMenuTriggerFor]=\"menu\" #menuTrigger=\"matMenuTrigger\" (click)=\"openToolTip()\" (mouseout)=\"closeToolTip()\" class=\"{{className}}\">{{displayValue}}</span> \n<mat-menu #menu [overlapTrigger]=\"false\" [hasBackdrop]=\"false\" class=\"padding-15 mat-elevation-z9\">\n      <ng-content></ng-content>\n</mat-menu>", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i7.MatLegacyMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "directive", type: i7.MatLegacyMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-tooltip', template: "<span *ngIf=\"triggerEvent==='hover'\" [matMenuTriggerFor]=\"menu\" #menuTrigger=\"matMenuTrigger\" (mouseenter)=\"openToolTip()\" (mouseout)=\"closeToolTip()\" class='tooltip-link'>{{displayValue}}</span>\n<span *ngIf=\"triggerEvent==='click'\" [matMenuTriggerFor]=\"menu\" #menuTrigger=\"matMenuTrigger\" (click)=\"openToolTip()\" (mouseout)=\"closeToolTip()\" class=\"{{className}}\">{{displayValue}}</span> \n<mat-menu #menu [overlapTrigger]=\"false\" [hasBackdrop]=\"false\" class=\"padding-15 mat-elevation-z9\">\n      <ng-content></ng-content>\n</mat-menu>" }]
        }], propDecorators: { displayValue: [{
                type: Input
            }], triggerEvent: [{
                type: Input
            }], className: [{
                type: Input
            }], menu: [{
                type: ViewChild,
                args: [MatLegacyMenu]
            }], trigger: [{
                type: ViewChild,
                args: [MatLegacyMenuTrigger]
            }], tooltipDelay: [{
                type: Input
            }] } });

class PershingConfirmationModalComponent {
    constructor(pershingModalService, data) {
        this.pershingModalService = pershingModalService;
        this.data = data;
        this.displayMessage = data;
    }
    ngOnInit() {
        //constructor is left blank intentionally
    }
    setConfirmationModalValue(value) {
        this.pershingModalService.setConfirmationModal(value);
        this.closeDialog();
    }
    closeDialog() {
        this.pershingModalService.closePershingModal('ExportMoreModalComponent');
    }
    ngOnDestroy() {
        this.pershingModalService.setConfirmationModal(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingConfirmationModalComponent, deps: [{ token: PershingModalService }, { token: MAT_LEGACY_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingConfirmationModalComponent, selector: "pershing-confirmation-modal", ngImport: i0, template: "<pershing-responsive [medium]=\"largeRef\" [small]=\"largeRef\" [large]=\"largeRef\"></pershing-responsive>\n<ng-template #largeRef>\n    <div>\n        <mat-dialog-content class=\"mat-dialog-content-padded\">\n            <span class=\"col-xs-2 col-sm-1 messaging-icon\"><i class=\"inline-icon fas fa-2x warning fa-exclamation-triangle\"></i></span>\n            <span class=\"middle-xs medium-weight no-gutters\">{{displayMessage}}</span>\n        </mat-dialog-content>\n        <div mat-dialog-actions>\n            <div class=\"action-buttons\">\n                <button mat-raised-button color=\"primary\" id=\"submitButton\"\n                    (click)=\"setConfirmationModalValue(true)\" > Yes </button>\n                <button mat-dialog-close mat-stroked-button color=\"primary\" class=\"negative-action\"\n                    (click)=\"setConfirmationModalValue(false)\" > No </button>\n            </div>\n        </div>\n    </div>\n</ng-template>", dependencies: [{ kind: "component", type: i4.MatLegacyButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i2$2.MatLegacyDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i2$2.MatLegacyDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i2$2.MatLegacyDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: PershingResponsiveComponent, selector: "pershing-responsive", inputs: ["respondToWindow", "small", "medium", "large"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingConfirmationModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-confirmation-modal', template: "<pershing-responsive [medium]=\"largeRef\" [small]=\"largeRef\" [large]=\"largeRef\"></pershing-responsive>\n<ng-template #largeRef>\n    <div>\n        <mat-dialog-content class=\"mat-dialog-content-padded\">\n            <span class=\"col-xs-2 col-sm-1 messaging-icon\"><i class=\"inline-icon fas fa-2x warning fa-exclamation-triangle\"></i></span>\n            <span class=\"middle-xs medium-weight no-gutters\">{{displayMessage}}</span>\n        </mat-dialog-content>\n        <div mat-dialog-actions>\n            <div class=\"action-buttons\">\n                <button mat-raised-button color=\"primary\" id=\"submitButton\"\n                    (click)=\"setConfirmationModalValue(true)\" > Yes </button>\n                <button mat-dialog-close mat-stroked-button color=\"primary\" class=\"negative-action\"\n                    (click)=\"setConfirmationModalValue(false)\" > No </button>\n            </div>\n        </div>\n    </div>\n</ng-template>" }]
        }], ctorParameters: function () { return [{ type: PershingModalService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_LEGACY_DIALOG_DATA]
                }] }]; } });

class AgGridThemeCSS {
    constructor(appSettings) {
        this.appSettings = appSettings;
        this.alpineBaseThemeCssUrl = 'node_modules/@pershing/netxwealth-branding/assets/css/build/theme/professional/ag-theme-alpine.css';
        this.materialThemeUrl = 'node_modules/@pershing/netxwealth-branding/assets/css/build/theme/professional/ag-theme.css';
        this.agGridBaseUrl = 'node_modules/@pershing/netxwealth-branding/assets/css/build/ag-grid/base.css';
        this.agGrid24BaseUrl = 'node_modules/@pershing/netxwealth-branding/assets/css/build/ag-grid/base-24.0.0.css';
    }
    ngOnDestroy() {
        console.log('OnDestroy() of css component - Pershing-Common');
        let processStyleUpdates = true;
        const gridThemeCssComponent = document.getElementsByTagName('ag-grid-theme-css');
        console.log(' componentList ', gridThemeCssComponent ? gridThemeCssComponent.length : gridThemeCssComponent);
        if (gridThemeCssComponent && gridThemeCssComponent.length > 0) {
            console.log('isAOT Flag -----' + this.appSettings.isAot);
            if (this.appSettings.isAot) {
                processStyleUpdates = false;
            }
            else {
                processStyleUpdates = true;
            }
        }
        if (processStyleUpdates) {
            console.log('OnDestroy() of css component - Pershing-Common - Processing style updates ');
            if (!String.prototype.includes) { // To check browser supports or not
                String.prototype.includes = function (str) {
                    return this.indexOf(str) !== -1;
                };
            }
            const styles = document.getElementsByTagName('link');
            for (let i = 0; i < styles.length; i++) { // removing the ag-grid alpine theme css styles on destroy
                if (styles[i].href.includes(this.alpineBaseThemeCssUrl)) {
                    styles[i].disabled = true;
                    styles[i].parentNode.removeChild(styles[i]);
                }
            }
            for (let i = 0; i < styles.length; i++) { // removing the ag-grid v24 base css styles on destroy
                if (styles[i].href.includes(this.agGrid24BaseUrl)) {
                    styles[i].disabled = true;
                    styles[i].parentNode.removeChild(styles[i]);
                }
            }
            for (let i = 0; i < styles.length; i++) { // removing the ag-grid v17 theme css styles on destroy
                if (styles[i].href.includes(this.materialThemeUrl)) {
                    styles[i].disabled = true;
                    styles[i].parentNode.removeChild(styles[i]);
                }
            }
            for (let i = 0; i < styles.length; i++) { // removing the ag-grid v17 base css styles on destroy
                if (styles[i].href.includes(this.agGridBaseUrl)) {
                    styles[i].disabled = true;
                    styles[i].parentNode.removeChild(styles[i]);
                }
            }
            // remove all style tags added by new ag-grid v24 on dom
            const agStyleTags = document.querySelectorAll('style');
            for (const agStyleTag of agStyleTags) {
                if (agStyleTag.textContent.includes('.ag')) {
                    agStyleTag.parentNode.removeChild(agStyleTag);
                }
            }
            // adding the v17 ag-grid theme css styling back
            const agthemelink = document.createElement('link');
            agthemelink.rel = 'stylesheet';
            agthemelink.href = this.materialThemeUrl;
            const basecsslink = document.createElement('link');
            basecsslink.rel = 'stylesheet';
            basecsslink.href = this.agGridBaseUrl;
            document.head.appendChild(basecsslink);
            document.head.appendChild(agthemelink);
        }
        else {
            console.log('OnDestroy() of css component - Pershing-Common - NOT Processing style updates ');
        }
        // const stylehtmlCollection: any = document.getElementsByTagName('link');
        // const appliedStyles = [...stylehtmlCollection];
        // if (appliedStyles.filter(e => e.href.includes(this.agGridBaseUrl)).length === 0 ) { // Checking if ag-grid base css is already applied
        //     const basecsslink = document.createElement('link');
        //     basecsslink.rel = 'stylesheet';
        //     basecsslink.href = this.agGridBaseUrl;
        //     document.head.appendChild(basecsslink);
        //   }
        // if (appliedStyles.filter(e => e.href.includes(this.materialThemeUrl)).length === 0) { // checking if material theme is applied
        //     const agthemelink = document.createElement('link');
        //     agthemelink.rel = 'stylesheet';
        //     agthemelink.href = this.materialThemeUrl;
        //     document.head.appendChild(agthemelink);
        //   }
    }
    ngOnInit() {
        console.log('OnInit() of css component - Pershing-Common');
        this.alpineBaseThemeCssUrl = PershingHttpUtil.resolveResourcePath('@pershing/netxwealth-branding', this.alpineBaseThemeCssUrl, this.appSettings);
        this.materialThemeUrl = PershingHttpUtil.resolveResourcePath('@pershing/netxwealth-branding', this.materialThemeUrl, this.appSettings);
        this.agGridBaseUrl = PershingHttpUtil.resolveResourcePath('@pershing/netxwealth-branding', this.agGridBaseUrl, this.appSettings);
        this.agGrid24BaseUrl = PershingHttpUtil.resolveResourcePath('@pershing/netxwealth-branding', this.agGrid24BaseUrl, this.appSettings);
        if (!String.prototype.includes) { // To check browser supports or not
            String.prototype.includes = function (str) {
                return this.indexOf(str) !== -1;
            };
        }
        const oldStyles = document.getElementsByTagName('link');
        for (let i = 0; i < oldStyles.length; i++) { // removing the ag-grid v17 material theme css styles on init
            if (oldStyles[i].href.includes(this.materialThemeUrl)) {
                oldStyles[i].disabled = true;
                oldStyles[i].parentNode.removeChild(oldStyles[i]);
            }
        }
        for (let i = 0; i < oldStyles.length; i++) { // removing the ag-grid v17 theme css styles on init
            if (oldStyles[i].href.includes(this.agGridBaseUrl)) {
                oldStyles[i].disabled = true;
                oldStyles[i].parentNode.removeChild(oldStyles[i]);
            }
        }
        for (let i = 0; i < oldStyles.length; i++) { // removing the ag-grid v17 material theme css styles on init
            if (oldStyles[i].href.includes(this.alpineBaseThemeCssUrl)) {
                oldStyles[i].disabled = true;
                oldStyles[i].parentNode.removeChild(oldStyles[i]);
            }
        }
        for (let i = 0; i < oldStyles.length; i++) { // removing the ag-grid v17 theme css styles on init
            if (oldStyles[i].href.includes(this.agGrid24BaseUrl)) {
                oldStyles[i].disabled = true;
                oldStyles[i].parentNode.removeChild(oldStyles[i]);
            }
        }
        // adding the v24 ag-grid theme css styling
        const agthemelink = document.createElement('link');
        agthemelink.rel = 'stylesheet';
        agthemelink.href = this.alpineBaseThemeCssUrl;
        const basecsslink = document.createElement('link');
        basecsslink.rel = 'stylesheet';
        basecsslink.href = this.agGrid24BaseUrl;
        document.head.appendChild(basecsslink);
        document.head.appendChild(agthemelink);
        // const stylehtmlCollection: any = document.getElementsByTagName('link');
        // const styles = [...stylehtmlCollection];
        // if (styles.filter(e => e.href.includes(this.agGrid24BaseUrl)).length === 0) { // checking if ag-grid v24 base css is already loaded
        //     const basecsslink = document.createElement('link');
        //     basecsslink.rel = 'stylesheet';
        //     basecsslink.href = this.agGrid24BaseUrl;
        //     document.head.appendChild(basecsslink);
        // }
        // if (styles.filter(e => e.href.includes(this.alpineBaseThemeCssUrl)).length === 0) { // checking if alpine base url is already url
        //     const agthemelink = document.createElement('link');
        //     agthemelink.rel = 'stylesheet';
        //     agthemelink.href = this.alpineBaseThemeCssUrl;
        //     document.head.appendChild(agthemelink);
        //     }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AgGridThemeCSS, deps: [{ token: 'AppSettings' }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AgGridThemeCSS, selector: "ag-grid-theme-css", ngImport: i0, template: '', isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AgGridThemeCSS, decorators: [{
            type: Component,
            args: [{
                    selector: 'ag-grid-theme-css',
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppSettings']
                }] }]; } });

/** Time and timing curve for expansion panel animations. */
const EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4,0.0,0.2,1)';
/** Animations used by the Material expansion panel. */
const slider = trigger('slider', [
    state('rtl', style({ transform: 'translate3d({{distance}}%,0,0)' }), {
        params: { distance: '0' }
    }),
    state('withoutRTL', style({ transform: 'translate3d({{distance}}%,0,0)' }), {
        params: { distance: '0' }
    }),
    transition('* => *', animate('200ms ease-in'))
]);

const PershingOverlayDefaultConfig = {
    renderOnce: false,
    timeout: 25,
    allowedPages: [],
};
class PershingOverlayComponent {
    constructor(appData, router, logService) {
        this.appData = appData;
        this.router = router;
        this.logService = logService;
        this.renderOnce = false;
        this.timeout = 30;
        // Assigned at Runtime
        this.canAnimate = true;
        this.isLoading = false;
        this.timerTriggered = false;
        this.loadingStateMap = {};
    }
    ngOnInit() {
        this.initializeConfiguration();
        this.initializeStateMap();
        this.routerSub = this.router.events.subscribe((event) => {
            if (event && event.url) {
                let routeParams = event.url.split('/');
                for (let param of routeParams) {
                    // Only listen to route if allowedPages are defined
                    if (this.allowedPages &&
                        this.allowedPages.length > 0 &&
                        this.isAllowedPage(param)) {
                        this.setPageLoadingState(param, true);
                    }
                }
            }
        });
    }
    initializeConfiguration() {
        let customOverlayConfiguration = this.appData.get(MessagingConstants.PERSHING_OVERLAY_CONFIG);
        let config = customOverlayConfiguration || PershingOverlayDefaultConfig;
        this.renderOnce = config.renderOnce;
        this.allowedPages = config.allowedPages;
        this.timeout = config.timeout;
    }
    initializeStateMap() {
        this.loadingStateMap = [];
        for (let page of this.allowedPages) {
            this.loadingStateMap[page] = false;
        }
    }
    setPageLoadingState(page, display) {
        if (this.isAllowedPage(page)) {
            this.loadingStateMap[page] = display;
            let pageStates = Object.keys(this.loadingStateMap).map((key) => this.loadingStateMap[key]);
            if (pageStates.every((val, i, arr) => val === arr[0])) {
                this.setDisplay(pageStates[0]); // XNOR condition to trigger display change only if entire state map is truthy or falsey
            }
        }
    }
    initLoadingEvent(event) {
        if (event.detail && event.detail.component) {
            this.setPageLoadingState(event.detail.component, true);
        }
        this.logService.info('Recieved Loading Event');
    }
    completeLoadingEvent(event) {
        if (event.detail && event.detail.component) {
            this.setPageLoadingState(event.detail.component, false);
        }
        this.logService.info('Recieved Loading Complete');
    }
    isAllowedPage(route) {
        let isAllowed = false;
        if (route) {
            if (this.allowedPages && this.allowedPages.length > 0) {
                isAllowed = this.allowedPages.indexOf(route) > -1;
            }
            else {
                isAllowed = true;
            }
        }
        return isAllowed;
    }
    setDisplay(visible) {
        if (visible) {
            if (this.renderOnce && this.canAnimate) {
                this.canAnimate = false;
                this.isLoading = true;
                this.overlayTimer();
            }
            else if (!this.renderOnce) {
                this.isLoading = true;
                this.overlayTimer();
            }
        }
        else {
            this.isLoading = false;
        }
    }
    overlayTimer() {
        if (!this.timerTriggered) {
            this.timerTriggered = true;
            setTimeout(this.clearOverlayState.bind(this), this.timeout * 1000);
        }
    }
    clearOverlayState() {
        this.initializeStateMap();
        this.setDisplay(false);
        this.timerTriggered = false;
    }
    ngOnDestroy() {
        if (this.routerSub) {
            this.routerSub.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingOverlayComponent, deps: [{ token: i1.AppDataStore }, { token: i2$4.Router }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: PershingOverlayComponent, selector: "pershing-overlay", host: { listeners: { "document:pershing.overlay.Loading": "initLoadingEvent($event)", "document:pershing.overlay.LoadingComplete": "completeLoadingEvent($event)" } }, ngImport: i0, template: "<div *ngIf=\"isLoading\" class=\"fw-LoaderOverlay\">\n    <div class=\"fw-LoaderInter\">\n        <div class=\"fw-LoaderInter_Bar\">\n            <div class=\"fw-LoaderInter_Logo-componentloading\"></div>\n        </div>\n    </div>\n</div>", dependencies: [{ kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pershing-overlay', template: "<div *ngIf=\"isLoading\" class=\"fw-LoaderOverlay\">\n    <div class=\"fw-LoaderInter\">\n        <div class=\"fw-LoaderInter_Bar\">\n            <div class=\"fw-LoaderInter_Logo-componentloading\"></div>\n        </div>\n    </div>\n</div>" }]
        }], ctorParameters: function () { return [{ type: i1.AppDataStore }, { type: i2$4.Router }, { type: i1.LogService }]; }, propDecorators: { initLoadingEvent: [{
                type: HostListener,
                args: ['document:pershing.overlay.Loading', ['$event']]
            }], completeLoadingEvent: [{
                type: HostListener,
                args: ['document:pershing.overlay.LoadingComplete', ['$event']]
            }] } });

class FluidHeightDirective {
    constructor(renderer, elementRef, logger) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.logger = logger;
        this.minHeight = 200; // if no min-height provided by calling component, set it to 200px - this is to avoid very small height for the smaller screens/monitors
        // This is the height below the grid (height for footer + height for disclaimers + disclosures) to be differenced with 
        // window height to get the remaining height available for the grid
        this.additionalComponentHeight = 110;
        this.overflowY = 'auto';
        // get ref HTML element 
        this.domElement = this.elementRef.nativeElement;
        // register on window resize event
        this.resizeSub = fromEvent(window, 'resize')
            .pipe(throttleTime(500), debounceTime(500))
            .subscribe(() => this.setHeight());
    }
    ngOnChanges() {
        if (!this.additionalComponentHeight) {
            this.additionalComponentHeight = 110;
        }
        if (!this.minHeight) {
            this.minHeight = 200;
        }
    }
    ngAfterViewInit() {
        // setTimeout is used to avoid getting wrong height (top offset) from the loading icons displayed while navigating between the screens
        setTimeout(() => this.setHeight(), 0);
    }
    ngOnDestroy() {
        this.resizeSub.unsubscribe();
    }
    setHeight() {
        if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
            this.renderer.setStyle(this.domElement, 'height', `72vh`);
            return;
        }
        const windowHeight = window?.innerHeight;
        const topOffset = this.topOffset || this.calcTopOffset();
        let height = windowHeight - (topOffset + Number(this.additionalComponentHeight));
        if (this.minHeight && height < this.minHeight) {
            height = this.minHeight;
        }
        this.renderer.setStyle(this.domElement, 'height', `${height}px`);
    }
    calcTopOffset() {
        try {
            const rect = this.domElement.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return rect.top + scrollTop;
        }
        catch (e) {
            return 0;
        }
    }
    handleRefreshGridHeightEvent(event) {
        this.setHeight();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FluidHeightDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i1.LogService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FluidHeightDirective, selector: "[fluidHeight]", inputs: { minHeight: "minHeight", additionalComponentHeight: "additionalComponentHeight", topOffset: ["fluidHeight", "topOffset"] }, host: { listeners: { "document:gridHeightRefresh": "handleRefreshGridHeightEvent($event)" }, properties: { "style.overflow-y": "this.overflowY" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FluidHeightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fluidHeight]',
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i1.LogService }]; }, propDecorators: { minHeight: [{
                type: Input
            }], additionalComponentHeight: [{
                type: Input
            }], topOffset: [{
                type: Input,
                args: ['fluidHeight']
            }], overflowY: [{
                type: HostBinding,
                args: ['style.overflow-y']
            }], handleRefreshGridHeightEvent: [{
                type: HostListener,
                args: ['document:gridHeightRefresh', ['$event']]
            }] } });

//   import {
//     HammerGestureConfig,
//     HAMMER_GESTURE_CONFIG,
//     HammerModule
//   } from '@angular/platform-browser';
class PershingCommonModule {
    static forRoot() {
        return {
            ngModule: PershingCommonModule,
            providers: [
                PershingModalService,
                ActionMenuService,
                ContentManagementService,
                FluidHeightDirective,
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PershingCommonModule, declarations: [LoginComponent,
            PershingDisclaimerComponent,
            NxpActionMenuComponent,
            AgGridThemeCSS,
            PershingMessageDialog,
            PershingMessageComponent,
            PershingIFrameComponent,
            PershingResponsiveComponent,
            PershingModalComponent,
            PershingInputComponent,
            PershingComponent,
            PershingOverlayComponent,
            PershingContentManagementComponent,
            PershingTooltipComponent,
            PershingConfirmationModalComponent,
            PershingEscapeHtmlPipe,
            FluidHeightDirective], imports: [PershingCoreModule,
            MatLegacyButtonModule,
            MatLegacyInputModule,
            MatLegacyAutocompleteModule,
            MatLegacyDialogModule,
            MatDividerModule,
            MatExpansionModule,
            MatLegacyFormFieldModule,
            MatIconModule,
            MatLegacyMenuModule,
            MatLegacyOptionModule,
            MatLegacyProgressSpinnerModule,
            MatLegacyTooltipModule,
            ReactiveFormsModule], exports: [LoginComponent,
            PershingDisclaimerComponent,
            NxpActionMenuComponent,
            PershingMessageDialog,
            PershingMessageComponent,
            AgGridThemeCSS,
            PershingIFrameComponent,
            PershingResponsiveComponent,
            PershingModalComponent,
            PershingInputComponent,
            PershingComponent,
            PershingOverlayComponent,
            PershingContentManagementComponent,
            PershingTooltipComponent,
            PershingConfirmationModalComponent,
            FluidHeightDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingCommonModule, imports: [PershingCoreModule,
            MatLegacyButtonModule,
            MatLegacyInputModule,
            MatLegacyAutocompleteModule,
            MatLegacyDialogModule,
            MatDividerModule,
            MatExpansionModule,
            MatLegacyFormFieldModule,
            MatIconModule,
            MatLegacyMenuModule,
            MatLegacyOptionModule,
            MatLegacyProgressSpinnerModule,
            MatLegacyTooltipModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PershingCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        PershingCoreModule,
                        MatLegacyButtonModule,
                        MatLegacyInputModule,
                        MatLegacyAutocompleteModule,
                        MatLegacyDialogModule,
                        MatDividerModule,
                        MatExpansionModule,
                        MatLegacyFormFieldModule,
                        MatIconModule,
                        MatLegacyMenuModule,
                        MatLegacyOptionModule,
                        MatLegacyProgressSpinnerModule,
                        MatLegacyTooltipModule,
                        ReactiveFormsModule,
                    ],
                    declarations: [
                        LoginComponent,
                        PershingDisclaimerComponent,
                        NxpActionMenuComponent,
                        AgGridThemeCSS,
                        PershingMessageDialog,
                        PershingMessageComponent,
                        PershingIFrameComponent,
                        PershingResponsiveComponent,
                        PershingModalComponent,
                        PershingInputComponent,
                        PershingComponent,
                        PershingOverlayComponent,
                        PershingContentManagementComponent,
                        PershingTooltipComponent,
                        PershingConfirmationModalComponent,
                        PershingEscapeHtmlPipe,
                        FluidHeightDirective,
                    ],
                    exports: [
                        LoginComponent,
                        PershingDisclaimerComponent,
                        NxpActionMenuComponent,
                        PershingMessageDialog,
                        PershingMessageComponent,
                        AgGridThemeCSS,
                        PershingIFrameComponent,
                        PershingResponsiveComponent,
                        PershingModalComponent,
                        PershingInputComponent,
                        PershingComponent,
                        PershingOverlayComponent,
                        PershingContentManagementComponent,
                        PershingTooltipComponent,
                        PershingConfirmationModalComponent,
                        FluidHeightDirective,
                    ],
                }]
        }] });

/*
 * Public API Surface of pershing-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionMenuContext, ActionMenuService, AgGridThemeCSS, Content, EXPANSION_PANEL_ANIMATION_TIMING, FluidHeightDirective, LoginComponent, MOCK_MENUITEAM, MessagingConstants, MockActionMenuService, NxpActionMenuComponent, NxpActionMenuConfig, PershingCommonModule, PershingComponent, PershingConfirmationModalComponent, PershingContentManagementComponent, PershingDisclaimerComponent, PershingIFrameComponent, PershingInputComponent, PershingMessageComponent, PershingMessageDialog, PershingModalComponent, PershingModalConfig, PershingModalProperties, PershingModalService, PershingOverlayComponent, PershingResponsiveComponent, PershingTooltipComponent, rolesData, slider };
